import { useState } from "react";

const API = "https://govdoc-ai-backend.onrender.com";

const C = {
  navy: "#003366", dark: "#00234B", orange: "#FF6600",
  white: "#FFFFFF", gray: "#666666", green: "#1a7a4a",
  red: "#cc0000", light: "#F5F5F5",
};

const SERVICES = [
  { id: "birth_certificate", label: "Birth Certificate", icon: "👶" },
  { id: "death_certificate", label: "Death Certificate", icon: "📋" },
  { id: "income_certificate", label: "Income Certificate", icon: "💰" },
  { id: "domicile_certificate", label: "Domicile Certificate", icon: "🏠" },
  { id: "caste_certificate", label: "Caste Certificate", icon: "📄" },
  { id: "marriage_certificate", label: "Marriage Certificate", icon: "💍" },
  { id: "driving_license", label: "Driving License", icon: "🚗" },
  { id: "pan_card", label: "PAN Card", icon: "🪪" },
  { id: "passport", label: "Passport", icon: "✈️" },
];

// ─── COMPONENTS OUTSIDE APP (fixes input focus bug) ───────────────────────────

function Card({ title, children }) {
  return (
    <div style={{ background: C.white, borderRadius: 4, boxShadow: "0 1px 4px rgba(0,0,0,0.12)", marginBottom: 20, overflow: "hidden" }}>
      <div style={{ background: C.navy, color: C.white, padding: "12px 20px", fontSize: 15, fontWeight: "bold", borderLeft: "5px solid " + C.orange }}>{title}</div>
      <div style={{ padding: 20 }}>{children}</div>
    </div>
  );
}

function Btn({ label, onClick, color, disabled }) {
  return (
    <button onClick={onClick} disabled={disabled}
      style={{ background: color || C.navy, color: C.white, border: "none", padding: "11px 28px", borderRadius: 3, fontSize: 14, fontWeight: "bold", cursor: "pointer", width: "100%", marginTop: 8, opacity: disabled ? 0.6 : 1 }}>
      {label}
    </button>
  );
}

function Input({ label, value, onChange, placeholder }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display: "block", fontSize: 13, fontWeight: "bold", color: C.navy, marginBottom: 5 }}>{label}</label>
      <input style={{ width: "100%", padding: "10px 12px", border: "1px solid #ccc", borderRadius: 3, fontSize: 14, boxSizing: "border-box" }}
        placeholder={placeholder} value={value} onChange={onChange} />
    </div>
  );
}

function Alert({ msg, type }) {
  if (!msg) return null;
  const bg = type === "error" ? "#f8d7da" : type === "success" ? "#d4edda" : "#cce5ff";
  const col = type === "error" ? "#721c24" : type === "success" ? "#155724" : "#004085";
  return <div style={{ padding: "10px 16px", borderRadius: 3, marginBottom: 14, fontSize: 13, background: bg, color: col, border: "1px solid #ccc" }}>{msg}</div>;
}

// ─── MAIN APP ─────────────────────────────────────────────────────────────────

export default function App() {
  const [page, setPage] = useState("home");
  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState("");
  const [appId, setAppId] = useState("");
  const [scores, setScores] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [dash, setDash] = useState(null);
  const [selectedService, setSelectedService] = useState("");
  const [statusData, setStatusData] = useState(null);
  const [regForm, setRegForm] = useState({ name: "", email: "", phone: "", city: "", state: "Maharashtra", aadhaar: "" });
  const [loginForm, setLoginForm] = useState({ email: "", phone: "", aadhaar: "" });
  const [officerComment, setOfficerComment] = useState({});
  const [officerApps, setOfficerApps] = useState([
    { id: "APP001", name: "Rahul Sharma", service: "Income Certificate", score: 78, status: "Pending", doc: "Aadhaar, Salary Slip" },
    { id: "APP002", name: "Priya Patil", service: "Domicile Certificate", score: 91, status: "Auto-Approved", doc: "Aadhaar, Address Proof" },
    { id: "APP003", name: "Amit Desai", service: "Caste Certificate", score: 65, status: "Pending", doc: "Aadhaar, Caste Proof" },
    { id: "APP004", name: "Sneha Kulkarni", service: "Birth Certificate", score: 88, status: "Pending", doc: "Hospital Record" },
    { id: "APP005", name: "Vikram Joshi", service: "Income Certificate", score: 45, status: "Rejected", doc: "Aadhaar (blurry)" },
  ]);

  // ── UNIVERSITY FEATURES STATE ─────────────────────────────────────────────
  const [qrVerifyId, setQrVerifyId] = useState("");
  const [qrResult, setQrResult] = useState(null);
  const [bulkFile, setBulkFile] = useState(null);
  const [bulkResults, setBulkResults] = useState([]);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [lockerDocs, setLockerDocs] = useState([
    { id: "MRK001", year: "SE", branch: "AI & DS", college: "MMIT Lohgaon", status: "Verified", score: 92, date: "2026-04-10" },
    { id: "MRK002", year: "FE", branch: "AI & DS", college: "MMIT Lohgaon", status: "Verified", score: 88, date: "2025-11-20" },
  ]);
  const [analyticsData] = useState({
    total: 142, verified: 98, pending: 28, rejected: 16,
    monthly: [
      { month: "Jan", count: 18 }, { month: "Feb", count: 24 }, { month: "Mar", count: 31 },
      { month: "Apr", count: 27 }, { month: "May", count: 42 },
    ],
    colleges: [
      { name: "MMIT Lohgaon", total: 45, fake: 2 },
      { name: "PICT Pune", total: 38, fake: 5 },
      { name: "COEP Pune", total: 31, fake: 1 },
      { name: "VIT Pune", total: 28, fake: 8 },
    ],
  });
  const [empVerifyId, setEmpVerifyId] = useState("");
  const [empResult, setEmpResult] = useState(null);

  // ── MARKS VERIFICATION STATE ──────────────────────────────────────────────
  const [marksForm, setMarksForm] = useState({ studentName: "", rollNo: "", collegeName: "", year: "", branch: "" });
  const [marksFile, setMarksFile] = useState(null);
  const [marksResult, setMarksResult] = useState(null);
  const [marksLoading, setMarksLoading] = useState(false);
  const [marksMsg, setMarksMsg] = useState("");
  const [marksApps, setMarksApps] = useState([
    { id: "MRK001", name: "Tanushri Choudhari", college: "MMIT Lohgaon", roll: "21AI045", year: "SE", branch: "AI & DS", score: 92, status: "Verified", checks: { name: true, roll: true, college: true, sign: true, seal: true } },
    { id: "MRK002", name: "Rohan Mehta", college: "PICT Pune", roll: "21CS102", year: "TE", branch: "CSE", score: 74, status: "Pending", checks: { name: true, roll: true, college: true, sign: false, seal: true } },
    { id: "MRK003", name: "Pooja Raut", college: "VIT Pune", roll: "20ME055", year: "BE", branch: "Mech", score: 41, status: "Rejected", checks: { name: true, roll: false, college: false, sign: false, seal: false } },
    { id: "MRK004", name: "Arjun Patil", college: "COEP Pune", roll: "22EC011", year: "FE", branch: "E&TC", score: 88, status: "Pending", checks: { name: true, roll: true, college: true, sign: true, seal: false } },
  ]);
  const [marksOfficerComment, setMarksOfficerComment] = useState({});

  // ── PAPER RE-EVALUATION STATE ─────────────────────────────────────────────
  const [revalForm, setRevalForm] = useState({ studentName: "", rollNo: "", collegeName: "", subject: "", year: "SE", branch: "AI & DS", reason: "", originalMarks: "" });
  const [revalApps, setRevalApps] = useState([
    { id: "REV001", name: "Tanushri Choudhari", roll: "21AI045", college: "MMIT Lohgaon", subject: "Data Structures", year: "SE", branch: "AI & DS", reason: "Marks seem less than expected", originalMarks: 38, revisedMarks: 52, status: "Marks Revised", submittedOn: "2026-04-15", reviewedOn: "2026-04-20", officerNote: "Internal marks calculation error found. Marks corrected." },
    { id: "REV002", name: "Rohan Mehta", roll: "21CS102", college: "PICT Pune", subject: "Operating Systems", year: "TE", branch: "CSE", reason: "Answer not checked properly", originalMarks: 45, revisedMarks: null, status: "Under Review", submittedOn: "2026-04-25", reviewedOn: null, officerNote: "" },
    { id: "REV003", name: "Arjun Patil", roll: "22EC011", college: "COEP Pune", subject: "Analog Electronics", year: "FE", branch: "E&TC", reason: "Totaling error suspected", originalMarks: 29, revisedMarks: 29, status: "No Change", submittedOn: "2026-04-10", reviewedOn: "2026-04-18", officerNote: "Re-checked by 2 teachers. Marks are correct." },
  ]);
  const [revalResult, setRevalResult] = useState(null);
  const [revalLoading, setRevalLoading] = useState(false);
  const [revalMsg, setRevalMsg] = useState("");
  const [revalOfficerComment, setRevalOfficerComment] = useState({});
  const [revalRevisedMarks, setRevalRevisedMarks] = useState({});

  const main = { maxWidth: 900, margin: "0 auto", padding: "24px 16px" };

  async function register() {
    setLoading(true); setMessage("");
    const res = await fetch(`${API}/api/register`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(regForm) });
    const data = await res.json();
    setLoading(false);
    if (data.user_id) { setUserId(data.user_id); setUserName(data.name); setPage("dashboard"); loadDash(data.user_id); }
    else setMessage(data.error || "Registration failed");
  }

  async function login() {
    setLoading(true); setMessage("");
    if (!/^\d{12}$/.test(loginForm.aadhaar)) {
      setMessage("Please enter a valid 12-digit Aadhaar number");
      setLoading(false); return;
    }
    if (loginForm.email === process.env.REACT_APP_OFFICER_EMAIL && loginForm.phone === process.env.REACT_APP_OFFICER_PHONE) {
      setLoading(false);
      setUserName("Rajesh Kumar (Officer)");
      setPage("officer");
      return;
    }
    const res = await fetch(`${API}/api/login`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(loginForm) });
    const data = await res.json();
    setLoading(false);
    if (data.user_id) { setUserId(data.user_id); setUserName(data.name); setPage("dashboard"); loadDash(data.user_id); }
    else setMessage(data.error || "Invalid credentials");
  }

  async function loadDash(uid) {
    const res = await fetch(`${API}/api/dashboard/${uid || userId}`);
    const data = await res.json();
    setDash(data);
  }

  async function applyService() {
    if (!selectedService) { setMessage("Please select a service"); return; }
    setLoading(true); setMessage("");
    const res = await fetch(`${API}/api/apply`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ user_id: userId, service: selectedService }) });
    const data = await res.json();
    setLoading(false);
    if (data.app_id) { setAppId(data.app_id); setPage("upload"); }
    else setMessage(data.error || "Failed");
  }

  async function uploadFile(e) {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true); setMessage("Uploading...");
    const form = new FormData();
    form.append("file", file);
    const res = await fetch(`${API}/api/upload/${appId}`, { method: "POST", body: form });
    const data = await res.json();
    setLoading(false);
    if (data.filename) setMessage("File uploaded! Total: " + data.total_docs);
    else setMessage(data.error || "Upload failed");
  }

  async function verify() {
    setLoading(true); setMessage("AI is verifying your documents...");
    const res = await fetch(`${API}/api/verify/${appId}`, { method: "POST" });
    const data = await res.json();
    setLoading(false);
    if (data.scores) { setScores(data); setPage("result"); }
    else setMessage(data.error || "Verification failed");
  }

  async function viewStatus(aid) {
    const res = await fetch(`${API}/api/status/${aid}`);
    const data = await res.json();
    setStatusData(data); setPage("status");
  }

  function logout() { setUserId(""); setUserName(""); setDash(null); setPage("home"); }

  function updateOfficerApp(id, newStatus) {
    setOfficerApps(prev => prev.map(a => a.id === id ? { ...a, status: newStatus } : a));
  }

  // ── MARKS VERIFICATION FUNCTIONS ─────────────────────────────────────────
  function verifyMarks() {
    const { studentName, rollNo, collegeName } = marksForm;
    if (!studentName || !rollNo || !collegeName) { setMarksMsg("Please fill all required fields."); return; }
    if (!marksFile) { setMarksMsg("Please upload the marksheet file."); return; }
    setMarksLoading(true); setMarksMsg("🤖 AI is analysing your marksheet...");
    setTimeout(() => {
      const nameOk = studentName.trim().length > 2;
      const rollOk = /^[0-9]{2}[A-Z]{2}[0-9]{3}$/.test(rollNo.trim().toUpperCase());
      const collegeOk = collegeName.trim().length > 3;
      const signOk = Math.random() > 0.25;
      const sealOk = Math.random() > 0.2;
      const checks = { name: nameOk, roll: rollOk, college: collegeOk, sign: signOk, seal: sealOk };
      const passed = Object.values(checks).filter(Boolean).length;
      const aiScore = Math.round((passed / 5) * 100 * (0.85 + Math.random() * 0.15));
      const status = aiScore >= 85 ? "Auto-Verified" : aiScore >= 60 ? "Pending Officer Review" : "Rejected";
      const newEntry = {
        id: "MRK" + String(marksApps.length + 5).padStart(3, "0"),
        name: studentName, college: collegeName, roll: rollNo.toUpperCase(),
        year: marksForm.year, branch: marksForm.branch, score: aiScore, status, checks,
      };
      setMarksApps(prev => [newEntry, ...prev]);
      setMarksResult({ ...newEntry });
      setMarksLoading(false);
      setMarksMsg("");
      setPage("marksResult");
    }, 2200);
  }

  function updateMarksApp(id, newStatus) {
    setMarksApps(prev => prev.map(a => a.id === id ? { ...a, status: newStatus } : a));
  }

  // ── PAPER RE-EVALUATION FUNCTIONS ─────────────────────────────────────────
  function submitReval() {
    const { studentName, rollNo, collegeName, subject, originalMarks, reason } = revalForm;
    if (!studentName || !rollNo || !collegeName || !subject || !originalMarks || !reason) {
      setRevalMsg("Please fill all required fields."); return;
    }
    setRevalLoading(true); setRevalMsg("📋 Submitting re-evaluation request...");
    setTimeout(() => {
      const newEntry = {
        id: "REV" + String(revalApps.length + 4).padStart(3, "0"),
        name: studentName, roll: rollNo.toUpperCase(), college: collegeName,
        subject, year: revalForm.year, branch: revalForm.branch, reason,
        originalMarks: parseInt(originalMarks) || 0,
        revisedMarks: null, status: "Under Review",
        submittedOn: new Date().toISOString().slice(0, 10),
        reviewedOn: null, officerNote: "",
      };
      setRevalApps(prev => [newEntry, ...prev]);
      setRevalResult(newEntry);
      setRevalLoading(false); setRevalMsg("");
      setPage("revalResult");
    }, 1800);
  }

  function updateRevalApp(id, newStatus, revisedMarks, note) {
    setRevalApps(prev => prev.map(a => a.id === id ? {
      ...a, status: newStatus,
      revisedMarks: revisedMarks !== undefined ? revisedMarks : a.revisedMarks,
      officerNote: note || a.officerNote,
      reviewedOn: new Date().toISOString().slice(0, 10),
    } : a));
  }

  // ── UNIVERSITY FEATURE FUNCTIONS ─────────────────────────────────────────
  function generateQR(id) {
    return `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://tanu-1906.github.io/governmentai/verify/${id}`;
  }

  function verifyQR() {
    if (!qrVerifyId.trim()) return;
    const found = marksApps.find(a => a.id === qrVerifyId.trim().toUpperCase());
    if (found) setQrResult({ ...found, genuine: found.status === "Verified" || found.status === "Auto-Verified" });
    else setQrResult({ genuine: false, notFound: true });
  }

  function verifyEmployer() {
    if (!empVerifyId.trim()) return;
    const found = marksApps.find(a => a.id === empVerifyId.trim().toUpperCase());
    if (found) setEmpResult({ ...found, genuine: found.status === "Verified" || found.status === "Auto-Verified" });
    else setEmpResult({ genuine: false, notFound: true });
  }

  function bulkVerify() {
    if (!bulkFile) return;
    setBulkLoading(true);
    setTimeout(() => {
      const names = ["Amit Shah", "Priya Desai", "Rahul More", "Sneha Kulkarni", "Vikram Joshi", "Pooja Raut", "Arjun Patil", "Meera Nair"];
      const results = names.map((name, i) => {
        const score = Math.floor(40 + Math.random() * 60);
        return {
          id: "BULK" + String(i + 1).padStart(3, "0"),
          name, roll: `2${i}AI0${String(i + 1).padStart(2, "0")}`,
          score, status: score >= 85 ? "Verified" : score >= 60 ? "Pending Review" : "Rejected",
        };
      });
      setBulkResults(results);
      setBulkLoading(false);
    }, 3000);
  }

  function sendNotification(app) {
    alert(`📧 Notification Sent!\n\nTo: ${app.name}\nSMS: Your marksheet ${app.id} status is "${app.status}"\nEmail: verification@govdocai.gov.in\n\n✅ Student will be notified shortly!`);
  }

  function Header() {
    return (
      <div>
        <div style={{ background: C.dark, color: C.white, padding: "6px 20px", display: "flex", justifyContent: "space-between", fontSize: 12 }}>
          <span>🇮🇳 भारत सरकार | Government of India</span>
          <span>Screen Reader Access | A- A A+</span>
        </div>
        <div style={{ background: "linear-gradient(135deg," + C.navy + "," + C.dark + ")", padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "4px solid " + C.orange }}>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <div style={{ width: 64, height: 64, borderRadius: "50%", background: "white", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 0 3px #FF9933, 0 0 0 5px white, 0 0 0 7px #138808" }}>
                <svg width="48" height="48" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="50" cy="50" r="45" fill="white" stroke="#003366" strokeWidth="2"/>
                  <circle cx="50" cy="50" r="38" fill="none" stroke="#003366" strokeWidth="1.5"/>
                  <circle cx="50" cy="50" r="6" fill="#003366"/>
                  {[...Array(24)].map((_, i) => {
                    const angle = (i * 360) / 24;
                    const rad = (angle * Math.PI) / 180;
                    const x1 = 50 + 6 * Math.cos(rad); const y1 = 50 + 6 * Math.sin(rad);
                    const x2 = 50 + 38 * Math.cos(rad); const y2 = 50 + 38 * Math.sin(rad);
                    const mx = 50 + 22 * Math.cos(rad + (Math.PI / 24)); const my = 50 + 22 * Math.sin(rad + (Math.PI / 24));
                    return <path key={i} d={`M${x1},${y1} Q${mx},${my} ${x2},${y2}`} stroke="#003366" strokeWidth="1.2" fill="none"/>;
                  })}
                </svg>
              </div>
            <div style={{ color: C.white }}>
              <div style={{ fontSize: 22, fontWeight: "bold" }}>GovDoc AI Portal</div>
              <div style={{ fontSize: 12, color: "#aac4e0" }}>गवर्नमेंट डॉक्यूमेंट वेरिफिकेशन पोर्टल</div>
              <div style={{ fontSize: 11, color: C.orange }}>Ministry of Electronics & IT | Pune Municipal Corporation</div>
            </div>
          </div>
          <div style={{ textAlign: "right", color: C.white }}>
            <div style={{ display: "flex", gap: 3, marginBottom: 6, justifyContent: "flex-end" }}>
              <div style={{ width: 40, height: 8, background: "#FF9933", borderRadius: 1 }} />
              <div style={{ width: 40, height: 8, background: "#FFFFFF", borderRadius: 1 }} />
              <div style={{ width: 40, height: 8, background: "#138808", borderRadius: 1 }} />
            </div>
            {userName && <div style={{ fontSize: 13, color: "#aac4e0" }}>Welcome, {userName}</div>}
            {userName && (
              <button onClick={logout} style={{ background: "transparent", border: "1px solid " + C.orange, color: C.orange, padding: "4px 12px", borderRadius: 3, cursor: "pointer", fontSize: 12, marginTop: 4 }}>
                Logout
              </button>
            )}
          </div>
        </div>
        <div style={{ background: C.orange, display: "flex", padding: "0 24px" }}>
          {[
            { label: "Home", go: "home" },
            { label: "Services", go: userId ? "apply" : "login" },
            { label: "Track Application", go: userId ? "dashboard" : "login" },
            { label: "🎓 Marks Verify", go: userId ? "marks" : "login" },
            { label: "📝 Re-Evaluation", go: userId ? "reval" : "login" },
            { label: "🔍 QR Verify", go: "qrVerify" },
            { label: "🏢 Employer Verify", go: "employerVerify" },
            { label: "Help & Support", go: "help" },
            { label: "About", go: "about" },
          ].map(item => (
            <div key={item.label}
              onClick={() => setPage(item.go)}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(0,0,0,0.2)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}
              style={{ color: C.white, padding: "10px 18px", cursor: "pointer", fontSize: 13, fontWeight: "600", borderRight: "1px solid rgba(255,255,255,0.3)" }}>
              {item.label}
            </div>
          ))}
          {userName && (
            <div onClick={() => { setPage("dashboard"); loadDash(); }}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(0,0,0,0.2)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}
              style={{ color: C.white, padding: "10px 18px", cursor: "pointer", fontSize: 13, fontWeight: "600", marginLeft: "auto" }}>
              My Dashboard
            </div>
          )}
        </div>
      </div>
    );
  }

  function Footer() {
    return (
      <div style={{ background: C.dark, color: "#aac4e0", padding: "20px 24px", marginTop: 40, fontSize: 12, textAlign: "center" }}>
        <div style={{ marginBottom: 8 }}><strong style={{ color: C.white }}>GovDoc AI Portal</strong> — Government of India Initiative</div>
        <div style={{ marginBottom: 8 }}>Ministry of Electronics & Information Technology | Pune Municipal Corporation</div>
        <div style={{ display: "flex", justifyContent: "center", gap: 20, marginBottom: 8 }}>
          {["Privacy Policy", "Terms of Use", "Contact Us", "RTI", "Sitemap"].map(l => (
            <span key={l} style={{ color: C.orange, cursor: "pointer" }}>{l}</span>
          ))}
        </div>
        <div>2026 Government of India. All Rights Reserved.</div>
      </div>
    );
  }

  // HOME PAGE
  if (page === "home") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <div style={{ background: "linear-gradient(135deg," + C.navy + "," + C.dark + ")", borderRadius: 4, padding: "30px 24px", marginBottom: 20, borderLeft: "6px solid " + C.orange, color: C.white }}>
          <h2 style={{ margin: "0 0 8px", fontSize: 22 }}>🇮🇳 Digital India — Document Verification Portal</h2>
          <p style={{ margin: "0 0 16px", color: "#aac4e0", fontSize: 14 }}>AI-powered government document verification system. Apply for certificates, track status, and get instant AI verification.</p>
          <div style={{ display: "flex", gap: 12 }}>
            <button onClick={() => setPage("register")} style={{ background: C.orange, color: C.white, border: "none", padding: "10px 20px", borderRadius: 3, fontSize: 14, fontWeight: "bold", cursor: "pointer" }}>📋 Register as Citizen</button>
            <button onClick={() => setPage("login")} style={{ background: "transparent", border: "2px solid " + C.white, color: C.white, padding: "10px 20px", borderRadius: 3, fontSize: 14, fontWeight: "bold", cursor: "pointer" }}>🔐 Citizen Login</button>
            <button onClick={() => setPage(userId ? "marks" : "login")} style={{ background: "#1a7a4a", border: "none", color: C.white, padding: "10px 20px", borderRadius: 3, fontSize: 14, fontWeight: "bold", cursor: "pointer" }}>🎓 Marks Verification</button>
          </div>
        </div>
        <Card title="🏛️ Government Certificate Services">
          <p style={{ fontSize: 12, color: C.gray, marginBottom: 12, marginTop: 0 }}>Apply for official government certificates issued by Pune Municipal Corporation & State Government</p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
            {SERVICES.map(s => (
              <div key={s.id} onClick={() => setPage(userId ? "apply" : "login")}
                style={{ border: "2px solid #ddd", borderRadius: 6, padding: "16px 10px", textAlign: "center", cursor: "pointer", background: C.white, transition: "border 0.2s" }}
                onMouseEnter={e => e.currentTarget.style.borderColor = C.orange}
                onMouseLeave={e => e.currentTarget.style.borderColor = "#ddd"}>
                <div style={{ fontSize: 30, marginBottom: 8 }}>{s.icon}</div>
                <div style={{ fontSize: 12, fontWeight: "bold", color: C.navy }}>{s.label}</div>
                <div style={{ fontSize: 10, color: C.gray, marginTop: 4 }}>Click to Apply</div>
              </div>
            ))}
          </div>
        </Card>

        <Card title="🏫 University & School Services">
          <p style={{ fontSize: 12, color: C.gray, marginBottom: 12, marginTop: 0 }}>Academic document verification, marksheet validation and school/university-level services</p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
            {[
              { icon: "🎓", title: "Marks Verification", desc: "AI-verify your marksheet instantly", page: userId ? "marks" : "login", color: C.green },
              { icon: "📦", title: "Bulk Verification", desc: "Verify 100s of marksheets at once", page: userId ? "bulk" : "login", color: "#1565c0" },
              { icon: "📱", title: "QR Code Verify", desc: "Scan QR to check genuineness", page: "qrVerify", color: "#6a1b9a" },
              { icon: "📧", title: "Auto Notifications", desc: "SMS & Email alerts for students", page: userId ? "marksDash" : "login", color: "#00695c" },
              { icon: "📊", title: "Analytics Dashboard", desc: "Charts, stats, college-wise reports", page: "analytics", color: "#e65100" },
              { icon: "🏢", title: "Employer Portal", desc: "Companies verify certificates instantly", page: "employerVerify", color: "#558b2f" },
              { icon: "📁", title: "Digital Locker", desc: "Store all marksheets in one place", page: userId ? "locker" : "login", color: "#4527a0" },
              { icon: "📝", title: "Paper Re-Evaluation", desc: "Challenge wrong marks — request recheck", page: userId ? "reval" : "login", color: "#c62828" },
            ].map(f => (
              <div key={f.title} onClick={() => setPage(f.page)}
                style={{ border: "2px solid " + f.color, borderRadius: 6, padding: 14, textAlign: "center", cursor: "pointer", background: "#fafafa" }}
                onMouseEnter={e => e.currentTarget.style.background = "#f0f4ff"}
                onMouseLeave={e => e.currentTarget.style.background = "#fafafa"}>
                <div style={{ fontSize: 28, marginBottom: 6 }}>{f.icon}</div>
                <div style={{ fontWeight: "bold", color: f.color, fontSize: 13 }}>{f.title}</div>
                <div style={{ fontSize: 11, color: C.gray, marginTop: 4 }}>{f.desc}</div>
              </div>
            ))}
          </div>
        </Card>
      </div>
      <Footer />
    </div>
  );

  // REGISTER PAGE
  if (page === "register") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title="Citizen Registration — नागरिक पंजीकरण">
          <Alert msg={message} type="error" />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <Input label="Full Name *" value={regForm.name} placeholder="As per Aadhaar" onChange={e => setRegForm({ ...regForm, name: e.target.value })} />
            <Input label="Email Address *" value={regForm.email} placeholder="example@gmail.com" onChange={e => setRegForm({ ...regForm, email: e.target.value })} />
            <Input label="Mobile Number *" value={regForm.phone} placeholder="10-digit mobile" onChange={e => setRegForm({ ...regForm, phone: e.target.value })} />
            <Input label="Aadhaar Number" value={regForm.aadhaar} placeholder="12-digit Aadhaar" onChange={e => setRegForm({ ...regForm, aadhaar: e.target.value })} />
            <Input label="City / District *" value={regForm.city} placeholder="Pune" onChange={e => setRegForm({ ...regForm, city: e.target.value })} />
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 13, fontWeight: "bold", color: C.navy, marginBottom: 5 }}>State *</label>
              <select style={{ width: "100%", padding: "10px 12px", border: "1px solid #ccc", borderRadius: 3, fontSize: 14, boxSizing: "border-box" }}
                value={regForm.state} onChange={e => setRegForm({ ...regForm, state: e.target.value })}>
                {["Maharashtra", "Delhi", "Karnataka", "Tamil Nadu", "Gujarat", "Rajasthan", "UP", "MP"].map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
          </div>
          <Btn label={loading ? "Registering..." : "Register Now"} onClick={register} disabled={loading} />
          <Btn label="Already registered? Login here" onClick={() => setPage("login")} color="#888" />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // LOGIN PAGE
  if (page === "login") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={{ maxWidth: 460, margin: "24px auto", padding: "0 16px" }}>
        <Card title="Citizen Login — नागरिक लॉगिन">
          <Alert msg={message} type="error" />
          <Input label="Registered Email *" value={loginForm.email} placeholder="Enter your email" onChange={e => setLoginForm({ ...loginForm, email: e.target.value })} />
          <Input label="Registered Mobile *" value={loginForm.phone} placeholder="Enter mobile number" onChange={e => setLoginForm({ ...loginForm, phone: e.target.value })} />
          <Input label="Aadhaar Number *" value={loginForm.aadhaar} placeholder="Enter 12-digit Aadhaar number" onChange={e => setLoginForm({ ...loginForm, aadhaar: e.target.value })} />
          <Btn label={loading ? "Logging in..." : "Login to Portal"} onClick={login} disabled={loading} />
          <Btn label="New citizen? Register here" onClick={() => setPage("register")} color="#888" />
          <Btn label="Back to Home" onClick={() => setPage("home")} color="#555" />
          <div style={{ marginTop: 16, padding: 12, background: "#f0f4ff", borderRadius: 4, fontSize: 12, color: C.gray, textAlign: "center" }}>
            🧑‍💼 Are you an officer? <span onClick={() => setPage("officerLogin")} style={{ color: C.navy, fontWeight: "bold", cursor: "pointer", textDecoration: "underline" }}>Click here for Officer Login</span>
          </div>
        </Card>
      </div>
      <Footer />
    </div>
  );

  // OFFICER LOGIN PAGE
  if (page === "officerLogin") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={{ maxWidth: 460, margin: "24px auto", padding: "0 16px" }}>
        <Card title="🧑‍💼 Officer Login — अधिकारी लॉगिन">
          <div style={{ background: "#fff3e0", border: "1px solid #FF6600", borderRadius: 4, padding: 12, marginBottom: 16, fontSize: 12, color: "#e65100" }}>
            ⚠️ This portal is for authorized government officers only. Unauthorized access is punishable under IT Act 2000.
          </div>
          <Alert msg={message} type="error" />
          <Input
            label="Officer Email ID *"
            value={loginForm.email}
            placeholder="Enter your official email"
            onChange={e => setLoginForm({ ...loginForm, email: e.target.value })}
          />
          <Input
            label="Officer Mobile / Password *"
            value={loginForm.phone}
            placeholder="Enter mobile or password"
            onChange={e => setLoginForm({ ...loginForm, phone: e.target.value })}
          />
          <Input
            label="Employee ID *"
            value={loginForm.aadhaar}
            placeholder="Enter your government employee ID"
            onChange={e => setLoginForm({ ...loginForm, aadhaar: e.target.value })}
          />
          <Btn
            label={loading ? "Verifying..." : "Login as Officer"}
            onClick={async () => {
              setLoading(true); setMessage("");
              if (loginForm.email === process.env.REACT_APP_OFFICER_EMAIL && loginForm.phone === process.env.REACT_APP_OFFICER_PHONE) {
                setLoading(false);
                setUserName("Rajesh Kumar (Officer)");
                setPage("officer");
              } else {
                setLoading(false);
                setMessage("Invalid officer credentials. Access denied.");
              }
            }}
            disabled={loading}
          />
          <Btn label="← Back to Citizen Login" onClick={() => setPage("login")} color="#888" />
          <Btn label="Back to Home" onClick={() => setPage("home")} color="#555" />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // DASHBOARD PAGE
  if (page === "dashboard") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <div style={{ background: "linear-gradient(135deg," + C.navy + "," + C.dark + ")", borderRadius: 4, padding: "16px 20px", marginBottom: 16, borderLeft: "5px solid " + C.orange, color: C.white, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: "bold" }}>Welcome, {userName}!</div>
            <div style={{ fontSize: 12, color: "#aac4e0", marginTop: 2 }}>Citizen ID: {userId} | Pune Municipal Corporation</div>
          </div>
          <button onClick={() => { setSelectedService(""); setPage("apply"); }}
            style={{ background: C.orange, color: C.white, border: "none", padding: "10px 20px", borderRadius: 3, fontSize: 14, fontWeight: "bold", cursor: "pointer" }}>
            + New Application
          </button>
        </div>
        <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
          {[
            { label: "🎓 Verify Marksheet", page: "marks", color: C.green },
            { label: "📁 Digital Locker", page: "locker", color: "#4527a0" },
            { label: "📦 Bulk Verify", page: "bulk", color: "#1565c0" },
            { label: "📊 Analytics", page: "analytics", color: "#e65100" },
            { label: "📝 Re-Evaluation", page: "reval", color: "#c62828" },
          ].map(b => (
            <button key={b.label} onClick={() => setPage(b.page)} style={{ background: b.color, color: C.white, border: "none", padding: "8px 16px", borderRadius: 3, fontSize: 13, fontWeight: "bold", cursor: "pointer" }}>{b.label}</button>
          ))}
        </div>
        {dash && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12, marginBottom: 16 }}>
            {[{ n: dash.total, l: "Total Applications", bg: C.navy }, { n: dash.approved, l: "Approved", bg: C.green }, { n: dash.pending, l: "Pending", bg: C.orange }].map(s => (
              <div key={s.l} style={{ background: s.bg, color: C.white, borderRadius: 4, padding: "16px 12px", textAlign: "center" }}>
                <div style={{ fontSize: 28, fontWeight: "bold" }}>{s.n}</div>
                <div style={{ fontSize: 12, marginTop: 4 }}>{s.l}</div>
              </div>
            ))}
          </div>
        )}
        <Card title="My Applications">
          {dash?.applications?.length === 0 && (
            <div style={{ textAlign: "center", color: C.gray, padding: 20 }}>No applications yet. Click "+ New Application" to start.</div>
          )}
          {dash?.applications?.map(a => (
            <div key={a.app_id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: "1px solid #eee" }}>
              <div>
                <div style={{ fontWeight: "bold", color: C.navy, fontSize: 14 }}>{a.service?.replace(/_/g, " ").toUpperCase()}</div>
                <div style={{ fontSize: 12, color: C.gray }}>{a.app_id} | Applied: {a.created_at?.slice(0, 10)}{a.ai_score ? " | AI Score: " + a.ai_score + "%" : ""}</div>
              </div>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <span style={{ display: "inline-block", padding: "3px 10px", borderRadius: 12, fontSize: 11, fontWeight: "bold", textTransform: "uppercase", background: a.status === "approved" ? "#d4edda" : "#fff3cd", color: a.status === "approved" ? C.green : "#856404" }}>{a.status}</span>
                <button onClick={() => viewStatus(a.app_id)} style={{ background: C.navy, color: C.white, border: "none", padding: "5px 12px", borderRadius: 3, fontSize: 12, cursor: "pointer" }}>View</button>
              </div>
            </div>
          ))}
          <Btn label="Refresh" onClick={() => loadDash()} color="#888" />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // APPLY PAGE
  if (page === "apply") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title="Apply for Government Service">
          <Alert msg={message} type="error" />
          <p style={{ color: C.gray, fontSize: 13, marginBottom: 16 }}>Select the service you want to apply for:</p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12, marginBottom: 16 }}>
            {SERVICES.map(s => (
              <div key={s.id} onClick={() => setSelectedService(s.id)}
                style={{ border: "2px solid " + (selectedService === s.id ? C.orange : "#ddd"), borderRadius: 4, padding: "14px 10px", textAlign: "center", cursor: "pointer", background: selectedService === s.id ? "#fff3e6" : C.white }}>
                <div style={{ fontSize: 28, marginBottom: 6 }}>{s.icon}</div>
                <div style={{ fontSize: 12, fontWeight: "bold", color: C.navy }}>{s.label}</div>
              </div>
            ))}
          </div>
          <Btn label={loading ? "Processing..." : "Proceed to Document Upload"} onClick={applyService} disabled={loading || !selectedService} />
          <Btn label="Back to Dashboard" onClick={() => setPage("dashboard")} color="#888" />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // UPLOAD PAGE
  if (page === "upload") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title={"Upload Documents — Application: " + appId}>
          <Alert msg={message} type={message.includes("uploaded") ? "success" : "info"} />
          <div style={{ border: "2px dashed #ccc", borderRadius: 4, padding: 30, textAlign: "center", marginBottom: 16, background: "#fafafa" }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>📁</div>
            <div style={{ fontSize: 14, color: C.gray, marginBottom: 12 }}>Upload PDF, JPG, or PNG documents</div>
            <input type="file" onChange={uploadFile} accept=".pdf,.jpg,.jpeg,.png" style={{ display: "none" }} id="fileInput" />
            <label htmlFor="fileInput" style={{ background: C.navy, color: C.white, padding: "10px 24px", borderRadius: 3, cursor: "pointer", fontSize: 14, fontWeight: "bold" }}>Choose File</label>
          </div>
          <div style={{ padding: "10px", background: "#fff3cd", borderRadius: 3, fontSize: 12, marginBottom: 16 }}>
            Please upload clear, legible scans. Blurry or damaged documents may fail verification.
          </div>
          <Btn label={loading ? "AI Verifying..." : "Run AI Verification"} onClick={verify} disabled={loading} color={C.green} />
          <Btn label="Back to Dashboard" onClick={() => setPage("dashboard")} color="#888" />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // RESULT PAGE
  if (page === "result" && scores) return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title={"AI Verification Result — " + appId}>
          <div style={{ textAlign: "center", padding: "20px 0", borderBottom: "1px solid #eee", marginBottom: 20 }}>
            <div style={{ fontSize: 64, fontWeight: "bold", color: scores.scores?.overall >= 90 ? C.green : scores.scores?.overall >= 75 ? C.orange : C.red }}>
              {scores.scores?.overall}%
            </div>
            <div style={{ fontSize: 14, color: C.gray }}>AI Confidence Score</div>
            <div style={{ marginTop: 8 }}>
              <span style={{ display: "inline-block", padding: "3px 10px", borderRadius: 12, fontSize: 11, fontWeight: "bold", background: scores.status === "approved" ? "#d4edda" : "#fff3cd", color: scores.status === "approved" ? C.green : "#856404" }}>
                {scores.status?.replace(/_/g, " ")}
              </span>
            </div>
            <div style={{ marginTop: 8, fontSize: 13, color: C.navy, fontWeight: "bold" }}>{scores.message}</div>
          </div>
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontWeight: "bold", color: C.navy, marginBottom: 12 }}>Score Breakdown</div>
            {[
              ["OCR Extraction", scores.scores?.ocr_extraction],
              ["Document Authenticity", scores.scores?.document_authentic],
              ["Biometric Match", scores.scores?.biometric_match],
              ["Fraud Detection", scores.scores?.fraud_detection],
            ].map(([label, val]) => (
              <div key={label} style={{ marginBottom: 12 }}>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13 }}>
                  <span>{label}</span>
                  <span style={{ fontWeight: "bold" }}>{val}%</span>
                </div>
                <div style={{ background: "#eee", borderRadius: 5, height: 10, marginTop: 4 }}>
                  <div style={{ height: 10, borderRadius: 5, background: val >= 90 ? C.green : val >= 75 ? C.orange : C.red, width: val + "%", transition: "width 0.8s ease" }} />
                </div>
              </div>
            ))}
          </div>
          {scores.officer && (
            <div style={{ background: "#fff3cd", padding: 12, borderRadius: 3, marginBottom: 16, fontSize: 13 }}>
              <strong>Assigned Officer:</strong> {scores.officer}
            </div>
          )}
          <div style={{ background: "#f8f9fa", padding: 12, borderRadius: 3, fontSize: 12, marginBottom: 16 }}>
            <div><strong>Application ID:</strong> {appId}</div>
            <div><strong>Status:</strong> {scores.status}</div>
            <div><strong>Verdict:</strong> {scores.verdict}</div>
          </div>
          <Btn label="Go to Dashboard" onClick={() => { setPage("dashboard"); loadDash(); }} />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // STATUS PAGE
  if (page === "status" && statusData) return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title="Application Status">
          <div style={{ marginBottom: 16 }}>
            <span style={{ display: "inline-block", padding: "3px 10px", borderRadius: 12, fontSize: 11, fontWeight: "bold", background: "#d4edda", color: C.green }}>
              {statusData.status?.replace(/_/g, " ").toUpperCase()}
            </span>
          </div>
          {[
            ["Application ID", statusData.app_id],
            ["Service", statusData.service?.replace(/_/g, " ").toUpperCase()],
            ["Citizen Name", statusData.citizen],
            ["AI Score", statusData.ai_score ? statusData.ai_score + "%" : "Pending"],
            ["Documents", statusData.documents],
            ["Officer", statusData.officer || "Auto-processed"],
            ["Applied On", statusData.created_at?.slice(0, 10)],
            ["Last Updated", statusData.updated_at?.slice(0, 10)],
          ].map(([label, val]) => (
            <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #eee", fontSize: 13 }}>
              <span style={{ color: C.gray }}>{label}</span>
              <span style={{ fontWeight: "bold", color: C.navy }}>{val}</span>
            </div>
          ))}
          <Btn label="Back to Dashboard" onClick={() => setPage("dashboard")} />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // HELP PAGE
  if (page === "help") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title="Help & Support — सहायता केंद्र">
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontWeight: "bold", color: C.navy, fontSize: 16, marginBottom: 12 }}>Frequently Asked Questions</div>
            {[
              ["How do I apply for a certificate?", "Register as a citizen, login, click New Application, select your service, upload documents and run AI verification."],
              ["What documents do I need to upload?", "Upload clear scans of Aadhaar card, address proof, and any service-specific documents in PDF, JPG or PNG format."],
              ["How long does verification take?", "AI verification is instant. If sent for manual review, officer will process within 3-5 working days."],
              ["What is the AI Confidence Score?", "It is a score from 0-100 showing how authentic your documents are. Score above 90% means auto-approved."],
              ["Who is the assigned officer?", "If your score is between 75-90%, it is assigned to Rajesh Kumar, Pune Municipal Corporation for manual review."],
              ["Is my data safe?", "Yes. All data is encrypted and protected under IT Act 2000 and Personal Data Protection Act."],
            ].map(([q, a]) => (
              <div key={q} style={{ borderBottom: "1px solid #eee", padding: "12px 0" }}>
                <div style={{ fontWeight: "bold", color: C.navy, fontSize: 13, marginBottom: 4 }}>Q: {q}</div>
                <div style={{ fontSize: 13, color: C.gray }}>A: {a}</div>
              </div>
            ))}
          </div>
          <div style={{ background: "#f0f4ff", padding: 16, borderRadius: 4, marginBottom: 16 }}>
            <div style={{ fontWeight: "bold", color: C.navy, marginBottom: 12 }}>Contact Us</div>
            {[
              ["Helpline", "1800-111-555 (Toll Free)"],
              ["Email", "support@govdocai.gov.in"],
              ["Office", "Pune Municipal Corporation, Shivajinagar, Pune - 411005"],
              ["Working Hours", "Monday to Friday, 9:00 AM to 6:00 PM"],
            ].map(([label, val]) => (
              <div key={label} style={{ display: "flex", gap: 12, marginBottom: 8, fontSize: 13 }}>
                <span style={{ color: C.gray, minWidth: 120 }}>{label}:</span>
                <span style={{ fontWeight: "bold", color: C.navy }}>{val}</span>
              </div>
            ))}
          </div>
          <Btn label="Back to Home" onClick={() => setPage("home")} />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // ABOUT PAGE
  if (page === "about") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title="About GovDoc AI Portal — हमारे बारे में">
          <div style={{ background: "linear-gradient(135deg," + C.navy + "," + C.dark + ")", borderRadius: 4, padding: 20, marginBottom: 20, color: C.white }}>
            <div style={{ fontSize: 18, fontWeight: "bold", marginBottom: 8 }}>Our Mission</div>
            <div style={{ fontSize: 13, lineHeight: 1.7, color: "#aac4e0" }}>
              GovDoc AI Portal is a Digital India initiative to simplify government document verification using Artificial Intelligence. Our goal is to make government services accessible, transparent, and fast for every citizen of India.
            </div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
            {[["9+", "Services Available"], ["95%", "AI Accuracy"], ["1 min", "Verification Time"], ["100%", "Secure"]].map(([n, l]) => (
              <div key={l} style={{ background: C.orange, color: C.white, borderRadius: 4, padding: "16px 8px", textAlign: "center" }}>
                <div style={{ fontSize: 22, fontWeight: "bold" }}>{n}</div>
                <div style={{ fontSize: 11, marginTop: 4 }}>{l}</div>
              </div>
            ))}
          </div>
          <Card title="How It Works">
            {[
              ["1", "Register & Login", "Create your citizen account with Aadhaar and mobile number"],
              ["2", "Select Service", "Choose from 9+ government services like Birth Certificate, PAN, Passport"],
              ["3", "Upload Documents", "Upload clear scans of required documents in PDF, JPG or PNG"],
              ["4", "AI Verification", "Our AI engine verifies authenticity, OCR, biometrics and fraud detection"],
              ["5", "Get Result", "Receive instant AI score. High scores get auto-approved, others go for officer review"],
            ].map(([step, title, desc]) => (
              <div key={step} style={{ display: "flex", gap: 16, marginBottom: 16, alignItems: "flex-start" }}>
                <div style={{ background: C.orange, color: C.white, borderRadius: "50%", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold", flexShrink: 0 }}>{step}</div>
                <div>
                  <div style={{ fontWeight: "bold", color: C.navy, fontSize: 13 }}>{title}</div>
                  <div style={{ fontSize: 12, color: C.gray, marginTop: 2 }}>{desc}</div>
                </div>
              </div>
            ))}
          </Card>
          <Card title="Technology Used">
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
              {[
                ["⚛️", "React.js", "Frontend UI"],
                ["🐍", "Python Flask", "Backend API"],
                ["🍃", "MongoDB Atlas", "Database"],
                ["🤖", "AI/ML Engine", "Document Verification"],
                ["☁️", "Render.com", "Backend Hosting"],
                ["🌐", "Netlify", "Frontend Hosting"],
              ].map(([icon, name, desc]) => (
                <div key={name} style={{ border: "1px solid #ddd", borderRadius: 4, padding: 12, textAlign: "center" }}>
                  <div style={{ fontSize: 24, marginBottom: 4 }}>{icon}</div>
                  <div style={{ fontWeight: "bold", color: C.navy, fontSize: 13 }}>{name}</div>
                  <div style={{ fontSize: 11, color: C.gray }}>{desc}</div>
                </div>
              ))}
            </div>
          </Card>
          <div style={{ background: "#f0f4ff", padding: 16, borderRadius: 4, marginBottom: 16, textAlign: "center" }}>
            <div style={{ fontSize: 16, fontWeight: "bold", color: C.navy, marginBottom: 4 }}>Developed By</div>
            <div style={{ fontSize: 14, color: C.orange, fontWeight: "bold" }}>Tanushri Choudhari</div>
            <div style={{ fontSize: 12, color: C.gray }}>MMIT Lohgaon | AI & DS | 2026</div>
            <div style={{ fontSize: 12, color: C.gray, marginTop: 4 }}>Assignment Project — AI-Based Government Document Verification System</div>
          </div>
          <Btn label="Back to Home" onClick={() => setPage("home")} />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // OFFICER DASHBOARD PAGE
  if (page === "officer") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 16, marginBottom: 24 }}>
          {[
            { label: "Pending Review", value: officerApps.filter(a => a.status === "Pending").length, icon: "⏳", color: C.orange },
            { label: "Approved", value: officerApps.filter(a => a.status === "Approved").length, icon: "✅", color: C.green },
            { label: "Rejected", value: officerApps.filter(a => a.status === "Rejected").length, icon: "❌", color: C.red },
            { label: "Avg AI Score", value: Math.round(officerApps.reduce((s, a) => s + a.score, 0) / officerApps.length) + "%", icon: "🤖", color: C.navy },
          ].map(stat => (
            <div key={stat.label} style={{ background: C.white, borderRadius: 4, padding: 16, boxShadow: "0 1px 4px rgba(0,0,0,0.12)", borderTop: "4px solid " + stat.color }}>
              <div style={{ fontSize: 28 }}>{stat.icon}</div>
              <div style={{ fontSize: 26, fontWeight: "bold", color: stat.color }}>{stat.value}</div>
              <div style={{ fontSize: 12, color: C.gray }}>{stat.label}</div>
            </div>
          ))}
        </div>
        <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
          <button style={{ background: C.green, color: C.white, border: "none", padding: "10px 20px", borderRadius: 3, fontSize: 14, fontWeight: "bold", cursor: "pointer" }}
            onClick={() => setPage("marksOfficer")}>🎓 Review Marks Verifications ({marksApps.filter(a => a.status === "Pending" || a.status === "Pending Officer Review").length} Pending)</button>
          <button style={{ background: "#c62828", color: C.white, border: "none", padding: "10px 20px", borderRadius: 3, fontSize: 14, fontWeight: "bold", cursor: "pointer", marginLeft: 10 }}
            onClick={() => setPage("revalOfficer")}>📝 Review Re-Evaluations ({revalApps.filter(a => a.status === "Under Review").length} Pending)</button>
        </div>
        <Card title="🧑‍💼 Officer Dashboard — Applications for Review">
          {officerApps.map(app => (
            <div key={app.id} style={{ border: "1px solid #e0e0e0", borderRadius: 4, padding: 16, marginBottom: 16, background: "#fafafa" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                <div>
                  <span style={{ fontWeight: "bold", color: C.navy, fontSize: 15 }}>{app.name}</span>
                  <span style={{ marginLeft: 8, fontSize: 12, color: C.gray }}>#{app.id}</span>
                </div>
                <span style={{
                  padding: "4px 12px", borderRadius: 20, fontSize: 12, fontWeight: "bold",
                  background: app.status === "Approved" || app.status === "Auto-Approved" ? "#d4edda" : app.status === "Rejected" ? "#f8d7da" : "#fff3cd",
                  color: app.status === "Approved" || app.status === "Auto-Approved" ? C.green : app.status === "Rejected" ? C.red : "#856404"
                }}>{app.status}</span>
              </div>
              <div style={{ display: "flex", gap: 20, flexWrap: "wrap", marginBottom: 10, fontSize: 13 }}>
                <span>📋 <strong>Service:</strong> {app.service}</span>
                <span>📄 <strong>Docs:</strong> {app.doc}</span>
                <span>🤖 <strong>AI Score:</strong>
                  <strong style={{ marginLeft: 4, color: app.score >= 85 ? C.green : app.score >= 70 ? C.orange : C.red }}>{app.score}%</strong>
                </span>
              </div>
              <div style={{ background: "#e0e0e0", borderRadius: 4, height: 6, marginBottom: 12 }}>
                <div style={{ width: app.score + "%", height: 6, borderRadius: 4, background: app.score >= 85 ? C.green : app.score >= 70 ? C.orange : C.red }} />
              </div>
              <input
                placeholder="Add review comment..."
                value={officerComment[app.id] || ""}
                onChange={e => setOfficerComment({ ...officerComment, [app.id]: e.target.value })}
                style={{ width: "100%", padding: "8px 12px", border: "1px solid #ccc", borderRadius: 3, fontSize: 13, boxSizing: "border-box", marginBottom: 10 }}
              />
              {app.status === "Pending" && (
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <button style={{ background: C.green, color: C.white, border: "none", padding: "8px 16px", borderRadius: 3, cursor: "pointer", fontSize: 13, fontWeight: "bold" }}
                    onClick={() => { updateOfficerApp(app.id, "Approved"); alert("✅ " + app.id + " Approved!"); }}>✅ Approve</button>
                  <button style={{ background: C.red, color: C.white, border: "none", padding: "8px 16px", borderRadius: 3, cursor: "pointer", fontSize: 13, fontWeight: "bold" }}
                    onClick={() => { updateOfficerApp(app.id, "Rejected"); alert("❌ " + app.id + " Rejected!"); }}>❌ Reject</button>
                  <button style={{ background: C.orange, color: C.white, border: "none", padding: "8px 16px", borderRadius: 3, cursor: "pointer", fontSize: 13, fontWeight: "bold" }}
                    onClick={() => { updateOfficerApp(app.id, "Docs Requested"); alert("📄 More documents requested for " + app.id); }}>📄 Request Docs</button>
                  <button style={{ background: C.navy, color: C.white, border: "none", padding: "8px 16px", borderRadius: 3, cursor: "pointer", fontSize: 13, fontWeight: "bold" }}
                    onClick={() => alert("💬 Comment saved: " + (officerComment[app.id] || "(empty)"))}>💬 Save Comment</button>
                  <button style={{ background: "#9c27b0", color: C.white, border: "none", padding: "8px 16px", borderRadius: 3, cursor: "pointer", fontSize: 13, fontWeight: "bold" }}
                    onClick={() => alert("👤 " + app.id + " assigned to Rajesh Kumar, PMC")}>👤 Assign Officer</button>
                </div>
              )}
            </div>
          ))}
        </Card>
        <Btn label="← Back to Home" onClick={() => setPage("home")} color="#888" />
      </div>
      <Footer />
    </div>
  );

  // ── MARKS VERIFICATION UPLOAD PAGE ──────────────────────────────────────
  if (page === "marks") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title="🎓 College Marks Verification — कॉलेज मार्क्स वेरिफिकेशन">
          <div style={{ background: "linear-gradient(135deg,#1a7a4a,#0f4d2e)", borderRadius: 4, padding: 16, marginBottom: 20, color: C.white }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 4 }}>AI-Powered Marksheet Verification</div>
            <div style={{ fontSize: 12, color: "#a8e6c4" }}>Upload your marksheet and fill in your details. Our AI will verify authenticity, check college name, roll number, signatures & official seal.</div>
          </div>
          <Alert msg={marksMsg} type={marksMsg.includes("fill") || marksMsg.includes("upload") ? "error" : "info"} />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <Input label="Student Full Name *" value={marksForm.studentName} placeholder="As printed on marksheet" onChange={e => setMarksForm({ ...marksForm, studentName: e.target.value })} />
            <Input label="Roll Number *" value={marksForm.rollNo} placeholder="e.g. 21AI045" onChange={e => setMarksForm({ ...marksForm, rollNo: e.target.value })} />
            <Input label="College Name *" value={marksForm.collegeName} placeholder="e.g. MMIT Lohgaon" onChange={e => setMarksForm({ ...marksForm, collegeName: e.target.value })} />
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 13, fontWeight: "bold", color: C.navy, marginBottom: 5 }}>Academic Year</label>
              <select style={{ width: "100%", padding: "10px 12px", border: "1px solid #ccc", borderRadius: 3, fontSize: 14, boxSizing: "border-box" }}
                value={marksForm.year} onChange={e => setMarksForm({ ...marksForm, year: e.target.value })}>
                {["FE", "SE", "TE", "BE"].map(y => <option key={y}>{y}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 13, fontWeight: "bold", color: C.navy, marginBottom: 5 }}>Branch / Department</label>
              <select style={{ width: "100%", padding: "10px 12px", border: "1px solid #ccc", borderRadius: 3, fontSize: 14, boxSizing: "border-box" }}
                value={marksForm.branch} onChange={e => setMarksForm({ ...marksForm, branch: e.target.value })}>
                {["AI & DS", "CSE", "IT", "Mech", "Civil", "E&TC", "Electrical"].map(b => <option key={b}>{b}</option>)}
              </select>
            </div>
          </div>
          <div style={{ border: "2px dashed #1a7a4a", borderRadius: 4, padding: 24, textAlign: "center", marginBottom: 16, background: "#f0fff6" }}>
            <div style={{ fontSize: 36, marginBottom: 8 }}>📄</div>
            <div style={{ fontSize: 13, color: C.gray, marginBottom: 12 }}>Upload Marksheet (PDF, JPG, PNG)</div>
            {marksFile && <div style={{ fontSize: 12, color: C.green, marginBottom: 8, fontWeight: "bold" }}>✅ Selected: {marksFile.name}</div>}
            <input type="file" accept=".pdf,.jpg,.jpeg,.png" id="marksFile" style={{ display: "none" }} onChange={e => { setMarksFile(e.target.files[0]); setMarksMsg(""); }} />
            <label htmlFor="marksFile" style={{ background: C.green, color: C.white, padding: "10px 24px", borderRadius: 3, cursor: "pointer", fontSize: 14, fontWeight: "bold" }}>
              {marksFile ? "Change File" : "Choose Marksheet"}
            </label>
          </div>
          <div style={{ background: "#fff3cd", padding: 12, borderRadius: 3, fontSize: 12, marginBottom: 16 }}>
            ⚠️ Roll Number format: <strong>21AI045</strong> (2-digit year + 2-letter branch code + 3 digits). Upload a clear scan for best AI accuracy.
          </div>
          <Btn label={marksLoading ? "🤖 AI Verifying Marksheet..." : "🔍 Run AI Marks Verification"} onClick={verifyMarks} disabled={marksLoading} color={C.green} />
          <Btn label="View My Marks History" onClick={() => setPage("marksDash")} color={C.navy} />
          <Btn label="Back to Dashboard" onClick={() => setPage("dashboard")} color="#888" />
        </Card>
        <Card title="📋 What AI Checks in Your Marksheet">
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
            {[
              ["🧑‍🎓", "Student Name", "Matches name printed on marksheet"],
              ["🔢", "Roll Number", "Validates format & college assignment"],
              ["🏫", "College Name", "Verifies registered institution name"],
              ["✍️", "Official Signature", "AI detects controller of exam's signature"],
              ["🔏", "University Seal", "Checks for official university stamp/seal"],
              ["🔍", "Tamper Detection", "Detects any digital or physical alterations"],
            ].map(([icon, title, desc]) => (
              <div key={title} style={{ border: "1px solid #d4edda", borderRadius: 4, padding: 12, textAlign: "center", background: "#f0fff6" }}>
                <div style={{ fontSize: 24, marginBottom: 6 }}>{icon}</div>
                <div style={{ fontWeight: "bold", color: C.green, fontSize: 13 }}>{title}</div>
                <div style={{ fontSize: 11, color: C.gray, marginTop: 4 }}>{desc}</div>
              </div>
            ))}
          </div>
        </Card>
      </div>
      <Footer />
    </div>
  );

  // ── MARKS RESULT PAGE ────────────────────────────────────────────────────
  if (page === "marksResult" && marksResult) return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title={"🎓 AI Marks Verification Result — " + marksResult.id}>
          <div style={{ textAlign: "center", padding: "20px 0", borderBottom: "1px solid #eee", marginBottom: 20 }}>
            <div style={{ fontSize: 64, fontWeight: "bold", color: marksResult.score >= 85 ? C.green : marksResult.score >= 60 ? C.orange : C.red }}>
              {marksResult.score}%
            </div>
            <div style={{ fontSize: 14, color: C.gray }}>AI Authenticity Score</div>
            <div style={{ marginTop: 10 }}>
              <span style={{
                display: "inline-block", padding: "5px 16px", borderRadius: 12, fontSize: 13, fontWeight: "bold",
                background: marksResult.status === "Auto-Verified" ? "#d4edda" : marksResult.status === "Rejected" ? "#f8d7da" : "#fff3cd",
                color: marksResult.status === "Auto-Verified" ? C.green : marksResult.status === "Rejected" ? C.red : "#856404"
              }}>{marksResult.status}</span>
            </div>
            <div style={{ marginTop: 10, fontSize: 13, color: C.navy, fontWeight: "bold" }}>
              {marksResult.score >= 85 ? "✅ Marksheet is Authentic — Auto-Verified" : marksResult.score >= 60 ? "⏳ Sent for Officer Review" : "❌ Marksheet may be tampered — Rejected"}
            </div>
          </div>
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontWeight: "bold", color: C.navy, marginBottom: 12 }}>Verification Checks</div>
            {[
              ["🧑‍🎓 Student Name Match", marksResult.checks?.name],
              ["🔢 Roll Number Valid", marksResult.checks?.roll],
              ["🏫 College Name Verified", marksResult.checks?.college],
              ["✍️ Signature Detected", marksResult.checks?.sign],
              ["🔏 University Seal Found", marksResult.checks?.seal],
            ].map(([label, passed]) => (
              <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: "1px solid #eee", fontSize: 13 }}>
                <span>{label}</span>
                <span style={{ fontWeight: "bold", color: passed ? C.green : C.red }}>{passed ? "✅ Passed" : "❌ Failed"}</span>
              </div>
            ))}
          </div>
          <div style={{ background: "#f8f9fa", padding: 14, borderRadius: 3, fontSize: 13, marginBottom: 16 }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
              {[["Verification ID", marksResult.id], ["Student", marksResult.name], ["College", marksResult.college], ["Roll No", marksResult.roll], ["Year", marksResult.year], ["Branch", marksResult.branch]].map(([l, v]) => (
                <div key={l}><span style={{ color: C.gray }}>{l}: </span><strong style={{ color: C.navy }}>{v}</strong></div>
              ))}
            </div>
          </div>
          {marksResult.status === "Pending Officer Review" && (
            <div style={{ background: "#fff3cd", padding: 12, borderRadius: 3, marginBottom: 16, fontSize: 13 }}>
              📋 Your marksheet has been sent to <strong>Officer Rajesh Kumar, PMC</strong> for manual review. You will be notified within 3 working days.
            </div>
          )}
          <Btn label="Submit Another Marksheet" onClick={() => { setMarksResult(null); setMarksForm({ studentName: "", rollNo: "", collegeName: "", year: "FE", branch: "AI & DS" }); setMarksFile(null); setPage("marks"); }} color={C.green} />
          <Btn label="View Marks History" onClick={() => setPage("marksDash")} color={C.navy} />
          <Btn label="Back to Dashboard" onClick={() => setPage("dashboard")} color="#888" />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // ── MARKS STUDENT DASHBOARD PAGE ─────────────────────────────────────────
  if (page === "marksDash") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
          {[
            { label: "Total Submitted", value: marksApps.length, icon: "🎓", color: C.navy },
            { label: "Verified", value: marksApps.filter(a => a.status === "Auto-Verified" || a.status === "Verified").length, icon: "✅", color: C.green },
            { label: "Under Review", value: marksApps.filter(a => a.status === "Pending" || a.status === "Pending Officer Review").length, icon: "⏳", color: C.orange },
            { label: "Rejected", value: marksApps.filter(a => a.status === "Rejected").length, icon: "❌", color: C.red },
          ].map(stat => (
            <div key={stat.label} style={{ background: C.white, borderRadius: 4, padding: 16, boxShadow: "0 1px 4px rgba(0,0,0,0.12)", borderTop: "4px solid " + stat.color, textAlign: "center" }}>
              <div style={{ fontSize: 28 }}>{stat.icon}</div>
              <div style={{ fontSize: 24, fontWeight: "bold", color: stat.color }}>{stat.value}</div>
              <div style={{ fontSize: 12, color: C.gray }}>{stat.label}</div>
            </div>
          ))}
        </div>
        <Card title="🎓 My Marks Verification History">
          {marksApps.map(app => (
            <div key={app.id} style={{ border: "1px solid #d4edda", borderRadius: 4, padding: 16, marginBottom: 14, background: "#fafff9" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                <div>
                  <span style={{ fontWeight: "bold", color: C.navy, fontSize: 15 }}>{app.name}</span>
                  <span style={{ marginLeft: 8, fontSize: 12, color: C.gray }}>#{app.id}</span>
                </div>
                <span style={{
                  padding: "4px 12px", borderRadius: 20, fontSize: 12, fontWeight: "bold",
                  background: (app.status === "Verified" || app.status === "Auto-Verified") ? "#d4edda" : app.status === "Rejected" ? "#f8d7da" : "#fff3cd",
                  color: (app.status === "Verified" || app.status === "Auto-Verified") ? C.green : app.status === "Rejected" ? C.red : "#856404"
                }}>{app.status}</span>
              </div>
              <div style={{ display: "flex", gap: 20, flexWrap: "wrap", fontSize: 13, marginBottom: 10 }}>
                <span>🏫 <strong>{app.college}</strong></span>
                <span>🔢 Roll: <strong>{app.roll}</strong></span>
                <span>📚 {app.year} — {app.branch}</span>
                <span>🤖 AI Score: <strong style={{ color: app.score >= 85 ? C.green : app.score >= 60 ? C.orange : C.red }}>{app.score}%</strong></span>
              </div>
              <div style={{ background: "#e0e0e0", borderRadius: 4, height: 6, marginBottom: 10 }}>
                <div style={{ width: app.score + "%", height: 6, borderRadius: 4, background: app.score >= 85 ? C.green : app.score >= 60 ? C.orange : C.red }} />
              </div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", fontSize: 12 }}>
                {[["🧑‍🎓 Name", app.checks?.name], ["🔢 Roll", app.checks?.roll], ["🏫 College", app.checks?.college], ["✍️ Sign", app.checks?.sign], ["🔏 Seal", app.checks?.seal]].map(([l, v]) => (
                  <span key={l} style={{ padding: "2px 8px", borderRadius: 10, background: v ? "#d4edda" : "#f8d7da", color: v ? C.green : C.red, fontWeight: "bold" }}>{l} {v ? "✅" : "❌"}</span>
                ))}
              </div>
              <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
                <button onClick={() => sendNotification(app)} style={{ background: C.navy, color: C.white, border: "none", padding: "5px 12px", borderRadius: 3, fontSize: 12, cursor: "pointer" }}>📧 Send Notification</button>
                <button onClick={() => { setQrVerifyId(app.id); setPage("qrVerify"); }} style={{ background: "#6a1b9a", color: C.white, border: "none", padding: "5px 12px", borderRadius: 3, fontSize: 12, cursor: "pointer" }}>📱 QR Code</button>
              </div>
            </div>
          ))}
        </Card>
        <Btn label="+ Verify New Marksheet" onClick={() => { setMarksForm({ studentName: "", rollNo: "", collegeName: "", year: "FE", branch: "AI & DS" }); setMarksFile(null); setPage("marks"); }} color={C.green} />
        <Btn label="Back to Dashboard" onClick={() => setPage("dashboard")} color="#888" />
      </div>
      <Footer />
    </div>
  );

  // ── MARKS OFFICER REVIEW PAGE ────────────────────────────────────────────
  if (page === "marksOfficer") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
          {[
            { label: "Total", value: marksApps.length, icon: "🎓", color: C.navy },
            { label: "Verified", value: marksApps.filter(a => a.status === "Verified" || a.status === "Auto-Verified").length, icon: "✅", color: C.green },
            { label: "Pending Review", value: marksApps.filter(a => a.status === "Pending" || a.status === "Pending Officer Review").length, icon: "⏳", color: C.orange },
            { label: "Rejected", value: marksApps.filter(a => a.status === "Rejected").length, icon: "❌", color: C.red },
          ].map(stat => (
            <div key={stat.label} style={{ background: C.white, borderRadius: 4, padding: 16, boxShadow: "0 1px 4px rgba(0,0,0,0.12)", borderTop: "4px solid " + stat.color }}>
              <div style={{ fontSize: 28 }}>{stat.icon}</div>
              <div style={{ fontSize: 24, fontWeight: "bold", color: stat.color }}>{stat.value}</div>
              <div style={{ fontSize: 12, color: C.gray }}>{stat.label}</div>
            </div>
          ))}
        </div>
        <Card title="🧑‍💼 Officer Review — Marks Verification Applications">
          {marksApps.map(app => (
            <div key={app.id} style={{ border: "1px solid #e0e0e0", borderRadius: 4, padding: 16, marginBottom: 16, background: "#fafff9" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                <div>
                  <span style={{ fontWeight: "bold", color: C.navy, fontSize: 15 }}>{app.name}</span>
                  <span style={{ marginLeft: 8, fontSize: 12, color: C.gray }}>#{app.id} | {app.college}</span>
                </div>
                <span style={{
                  padding: "4px 12px", borderRadius: 20, fontSize: 12, fontWeight: "bold",
                  background: (app.status === "Verified" || app.status === "Auto-Verified") ? "#d4edda" : app.status === "Rejected" ? "#f8d7da" : "#fff3cd",
                  color: (app.status === "Verified" || app.status === "Auto-Verified") ? C.green : app.status === "Rejected" ? C.red : "#856404"
                }}>{app.status}</span>
              </div>
              <div style={{ display: "flex", gap: 16, flexWrap: "wrap", fontSize: 13, marginBottom: 10 }}>
                <span>🔢 Roll: <strong>{app.roll}</strong></span>
                <span>📚 {app.year} — {app.branch}</span>
                <span>🤖 AI Score: <strong style={{ color: app.score >= 85 ? C.green : app.score >= 60 ? C.orange : C.red }}>{app.score}%</strong></span>
              </div>
              <div style={{ background: "#e0e0e0", borderRadius: 4, height: 6, marginBottom: 10 }}>
                <div style={{ width: app.score + "%", height: 6, borderRadius: 4, background: app.score >= 85 ? C.green : app.score >= 60 ? C.orange : C.red }} />
              </div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", fontSize: 12, marginBottom: 12 }}>
                {[["🧑‍🎓 Name", app.checks?.name], ["🔢 Roll", app.checks?.roll], ["🏫 College", app.checks?.college], ["✍️ Sign", app.checks?.sign], ["🔏 Seal", app.checks?.seal]].map(([l, v]) => (
                  <span key={l} style={{ padding: "2px 8px", borderRadius: 10, background: v ? "#d4edda" : "#f8d7da", color: v ? C.green : C.red, fontWeight: "bold" }}>{l} {v ? "✅" : "❌"}</span>
                ))}
              </div>
              <input
                placeholder="Add review comment..."
                value={marksOfficerComment[app.id] || ""}
                onChange={e => setMarksOfficerComment({ ...marksOfficerComment, [app.id]: e.target.value })}
                style={{ width: "100%", padding: "8px 12px", border: "1px solid #ccc", borderRadius: 3, fontSize: 13, boxSizing: "border-box", marginBottom: 10 }}
              />
              {(app.status === "Pending" || app.status === "Pending Officer Review") && (
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <button style={{ background: C.green, color: C.white, border: "none", padding: "8px 16px", borderRadius: 3, cursor: "pointer", fontSize: 13, fontWeight: "bold" }}
                    onClick={() => { updateMarksApp(app.id, "Verified"); alert("✅ Marksheet " + app.id + " Verified!"); }}>✅ Verify</button>
                  <button style={{ background: C.red, color: C.white, border: "none", padding: "8px 16px", borderRadius: 3, cursor: "pointer", fontSize: 13, fontWeight: "bold" }}
                    onClick={() => { updateMarksApp(app.id, "Rejected"); alert("❌ Marksheet " + app.id + " Rejected!"); }}>❌ Reject</button>
                  <button style={{ background: C.orange, color: C.white, border: "none", padding: "8px 16px", borderRadius: 3, cursor: "pointer", fontSize: 13, fontWeight: "bold" }}
                    onClick={() => alert("📄 Requested original marksheet for " + app.id)}>📄 Request Original</button>
                  <button style={{ background: C.navy, color: C.white, border: "none", padding: "8px 16px", borderRadius: 3, cursor: "pointer", fontSize: 13, fontWeight: "bold" }}
                    onClick={() => alert("💬 Comment saved: " + (marksOfficerComment[app.id] || "(empty)"))}>💬 Save Comment</button>
                </div>
              )}
            </div>
          ))}
        </Card>
        <Btn label="← Back to Officer Dashboard" onClick={() => setPage("officer")} color="#888" />
      </div>
      <Footer />
    </div>
  );

  // ── QR CODE VERIFY PAGE ───────────────────────────────────────────────────
  if (page === "qrVerify") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title="📱 QR Code Verification — स्कैन & वेरीफाई">
          <div style={{ background: "linear-gradient(135deg,#6a1b9a,#4a148c)", borderRadius: 4, padding: 16, marginBottom: 20, color: C.white }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 4 }}>Instant QR Verification</div>
            <div style={{ fontSize: 12, color: "#e1bee7" }}>Each verified marksheet gets a unique QR code. Employers, colleges & universities can scan it to instantly confirm authenticity — no login needed!</div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
            <div>
              <div style={{ fontWeight: "bold", color: C.navy, marginBottom: 12 }}>🔍 Enter Verification ID</div>
              <Input label="Verification ID *" value={qrVerifyId} placeholder="e.g. MRK001" onChange={e => { setQrVerifyId(e.target.value); setQrResult(null); }} />
              <Btn label="Verify Now" onClick={verifyQR} color="#6a1b9a" />
              {qrResult && (
                <div style={{ marginTop: 16, padding: 16, borderRadius: 4, background: qrResult.genuine ? "#d4edda" : "#f8d7da", border: "2px solid " + (qrResult.genuine ? C.green : C.red) }}>
                  {qrResult.notFound ? (
                    <div style={{ color: C.red, fontWeight: "bold" }}>❌ No record found for this ID. Marksheet may be FAKE!</div>
                  ) : (
                    <>
                      <div style={{ fontWeight: "bold", fontSize: 16, color: qrResult.genuine ? C.green : C.red, marginBottom: 8 }}>
                        {qrResult.genuine ? "✅ GENUINE MARKSHEET" : "❌ NOT VERIFIED"}
                      </div>
                      {[["Student", qrResult.name], ["College", qrResult.college], ["Roll No", qrResult.roll], ["Year", qrResult.year], ["Branch", qrResult.branch], ["AI Score", qrResult.score + "%"], ["Status", qrResult.status]].map(([l, v]) => (
                        <div key={l} style={{ fontSize: 13, marginBottom: 4 }}><span style={{ color: C.gray }}>{l}: </span><strong>{v}</strong></div>
                      ))}
                    </>
                  )}
                </div>
              )}
            </div>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontWeight: "bold", color: C.navy, marginBottom: 12 }}>📱 Sample QR Code</div>
              <img src={generateQR("MRK001")} alt="QR Code" style={{ border: "4px solid #6a1b9a", borderRadius: 8, padding: 8 }} />
              <div style={{ fontSize: 12, color: C.gray, marginTop: 8 }}>Scan this QR to verify MRK001</div>
              <div style={{ marginTop: 16, background: "#f3e5f5", padding: 12, borderRadius: 4, fontSize: 12 }}>
                <div style={{ fontWeight: "bold", color: "#6a1b9a", marginBottom: 6 }}>How QR works:</div>
                <div>1. Student receives QR with marksheet</div>
                <div>2. Employer scans QR with phone</div>
                <div>3. Instantly sees if marksheet is REAL</div>
                <div>4. No login or account needed!</div>
              </div>
            </div>
          </div>
          <div style={{ marginTop: 20 }}>
            <div style={{ fontWeight: "bold", color: C.navy, marginBottom: 12 }}>🎓 QR Codes for All Verified Marksheets</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 12 }}>
              {marksApps.filter(a => a.status === "Verified" || a.status === "Auto-Verified").map(app => (
                <div key={app.id} style={{ border: "1px solid #ce93d8", borderRadius: 4, padding: 12, display: "flex", gap: 12, alignItems: "center", background: "#fdf7ff" }}>
                  <img src={generateQR(app.id)} alt="QR" style={{ width: 70, height: 70 }} />
                  <div>
                    <div style={{ fontWeight: "bold", color: C.navy, fontSize: 13 }}>{app.name}</div>
                    <div style={{ fontSize: 12, color: C.gray }}>{app.college}</div>
                    <div style={{ fontSize: 12, color: C.gray }}>Roll: {app.roll}</div>
                    <div style={{ fontSize: 11, color: C.green, fontWeight: "bold" }}>✅ {app.status}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Btn label="← Back to Home" onClick={() => setPage("home")} color="#888" />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // ── EMPLOYER VERIFY PAGE ──────────────────────────────────────────────────
  if (page === "employerVerify") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title="🏢 Employer Verification Portal — नियोक्ता वेरिफिकेशन">
          <div style={{ background: "linear-gradient(135deg,#558b2f,#33691e)", borderRadius: 4, padding: 16, marginBottom: 20, color: C.white }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 4 }}>For Companies & Recruiters</div>
            <div style={{ fontSize: 12, color: "#dcedc8" }}>No login required! Just enter the Verification ID given by the candidate. Instantly know if their marksheet is genuine — preventing fraud in hiring.</div>
          </div>
          <div style={{ maxWidth: 500, margin: "0 auto" }}>
            <Input label="Enter Candidate's Verification ID *" value={empVerifyId} placeholder="e.g. MRK001" onChange={e => { setEmpVerifyId(e.target.value); setEmpResult(null); }} />
            <Btn label="🔍 Verify Candidate's Marksheet" onClick={verifyEmployer} color="#558b2f" />
          </div>
          {empResult && (
            <div style={{ marginTop: 20, padding: 20, borderRadius: 4, background: empResult.genuine ? "#d4edda" : "#f8d7da", border: "3px solid " + (empResult.genuine ? C.green : C.red), maxWidth: 500, margin: "20px auto 0" }}>
              {empResult.notFound ? (
                <div>
                  <div style={{ color: C.red, fontWeight: "bold", fontSize: 18, marginBottom: 8 }}>⚠️ MARKSHEET NOT FOUND</div>
                  <div style={{ fontSize: 13, color: C.red }}>This ID does not exist in our database. The marksheet may be FAKE. Do not proceed with this candidate.</div>
                </div>
              ) : (
                <>
                  <div style={{ fontWeight: "bold", fontSize: 20, color: empResult.genuine ? C.green : C.red, marginBottom: 12, textAlign: "center" }}>
                    {empResult.genuine ? "✅ MARKSHEET IS GENUINE" : "❌ MARKSHEET NOT VERIFIED"}
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                    {[["Student Name", empResult.name], ["College", empResult.college], ["Roll No", empResult.roll], ["Year", empResult.year], ["Branch", empResult.branch], ["AI Score", empResult.score + "%"], ["Verification Status", empResult.status]].map(([l, v]) => (
                      <div key={l} style={{ padding: "6px 0", borderBottom: "1px solid rgba(0,0,0,0.1)", fontSize: 13 }}>
                        <div style={{ color: C.gray, fontSize: 11 }}>{l}</div>
                        <div style={{ fontWeight: "bold", color: C.navy }}>{v}</div>
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 12, padding: 10, background: "rgba(255,255,255,0.5)", borderRadius: 4, fontSize: 12, textAlign: "center" }}>
                    Verified by GovDoc AI Portal | Ministry of Electronics & IT
                  </div>
                </>
              )}
            </div>
          )}
          <div style={{ marginTop: 24 }}>
            <Card title="💡 Why Use Employer Verification?">
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
                {[
                  ["⚡", "Instant Results", "Verify in seconds, not days"],
                  ["🆓", "No Login Needed", "Free for all employers"],
                  ["🛡️", "Prevent Fraud", "Stop fake marksheet hiring"],
                  ["📊", "AI Powered", "95% accuracy guaranteed"],
                  ["🇮🇳", "Govt Backed", "Ministry of Electronics & IT"],
                  ["📱", "Mobile Friendly", "Works on any device"],
                ].map(([icon, title, desc]) => (
                  <div key={title} style={{ textAlign: "center", padding: 12, border: "1px solid #c5e1a5", borderRadius: 4, background: "#f9fbe7" }}>
                    <div style={{ fontSize: 24 }}>{icon}</div>
                    <div style={{ fontWeight: "bold", color: "#558b2f", fontSize: 13, marginTop: 4 }}>{title}</div>
                    <div style={{ fontSize: 11, color: C.gray, marginTop: 2 }}>{desc}</div>
                  </div>
                ))}
              </div>
            </Card>
          </div>
          <Btn label="← Back to Home" onClick={() => setPage("home")} color="#888" />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // ── BULK VERIFICATION PAGE ────────────────────────────────────────────────
  if (page === "bulk") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title="📦 Bulk Marksheet Verification — बल्क वेरिफिकेशन">
          <div style={{ background: "linear-gradient(135deg,#1565c0,#0d47a1)", borderRadius: 4, padding: 16, marginBottom: 20, color: C.white }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 4 }}>For Universities & Exam Departments</div>
            <div style={{ fontSize: 12, color: "#bbdefb" }}>Upload a ZIP or CSV file containing 100s of marksheets. Our AI will verify all of them simultaneously and give you a full report within minutes!</div>
          </div>
          <div style={{ border: "2px dashed #1565c0", borderRadius: 4, padding: 30, textAlign: "center", marginBottom: 16, background: "#e3f2fd" }}>
            <div style={{ fontSize: 48, marginBottom: 8 }}>📦</div>
            <div style={{ fontSize: 14, color: C.gray, marginBottom: 12 }}>Upload CSV file with student details OR ZIP with marksheet images</div>
            {bulkFile && <div style={{ fontSize: 13, color: "#1565c0", fontWeight: "bold", marginBottom: 8 }}>✅ Selected: {bulkFile.name} ({Math.round(bulkFile.size/1024)} KB)</div>}
            <input type="file" accept=".csv,.zip,.pdf" id="bulkFile" style={{ display: "none" }} onChange={e => { setBulkFile(e.target.files[0]); setBulkResults([]); }} />
            <label htmlFor="bulkFile" style={{ background: "#1565c0", color: C.white, padding: "10px 24px", borderRadius: 3, cursor: "pointer", fontSize: 14, fontWeight: "bold" }}>
              {bulkFile ? "Change File" : "Choose File"}
            </label>
          </div>
          <div style={{ background: "#fff3cd", padding: 12, borderRadius: 3, fontSize: 12, marginBottom: 16 }}>
            📋 <strong>CSV Format:</strong> Name, Roll Number, College, Year, Branch (one student per row)
          </div>
          <Btn label={bulkLoading ? "🤖 AI Verifying All Marksheets..." : "🚀 Start Bulk Verification"} onClick={bulkVerify} disabled={bulkLoading || !bulkFile} color="#1565c0" />
          {bulkLoading && (
            <div style={{ textAlign: "center", padding: 30 }}>
              <div style={{ fontSize: 40, marginBottom: 8 }}>⚙️</div>
              <div style={{ color: "#1565c0", fontWeight: "bold" }}>AI is processing all marksheets...</div>
              <div style={{ fontSize: 12, color: C.gray, marginTop: 4 }}>This may take a few seconds</div>
            </div>
          )}
          {bulkResults.length > 0 && (
            <div style={{ marginTop: 20 }}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12, marginBottom: 16 }}>
                {[
                  { label: "Total Processed", value: bulkResults.length, color: C.navy },
                  { label: "Verified", value: bulkResults.filter(r => r.status === "Verified").length, color: C.green },
                  { label: "Rejected", value: bulkResults.filter(r => r.status === "Rejected").length, color: C.red },
                ].map(s => (
                  <div key={s.label} style={{ background: s.color, color: C.white, borderRadius: 4, padding: 14, textAlign: "center" }}>
                    <div style={{ fontSize: 28, fontWeight: "bold" }}>{s.value}</div>
                    <div style={{ fontSize: 12 }}>{s.label}</div>
                  </div>
                ))}
              </div>
              <div style={{ fontWeight: "bold", color: C.navy, marginBottom: 12 }}>📋 Bulk Verification Results</div>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                <thead>
                  <tr style={{ background: C.navy, color: C.white }}>
                    {["ID", "Student Name", "Roll No", "AI Score", "Status", "Notify"].map(h => (
                      <th key={h} style={{ padding: "8px 10px", textAlign: "left" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {bulkResults.map((r, i) => (
                    <tr key={r.id} style={{ background: i % 2 === 0 ? "#f9f9f9" : C.white }}>
                      <td style={{ padding: "8px 10px" }}>{r.id}</td>
                      <td style={{ padding: "8px 10px" }}>{r.name}</td>
                      <td style={{ padding: "8px 10px" }}>{r.roll}</td>
                      <td style={{ padding: "8px 10px", fontWeight: "bold", color: r.score >= 85 ? C.green : r.score >= 60 ? C.orange : C.red }}>{r.score}%</td>
                      <td style={{ padding: "8px 10px" }}>
                        <span style={{ padding: "2px 8px", borderRadius: 10, fontSize: 11, fontWeight: "bold", background: r.status === "Verified" ? "#d4edda" : r.status === "Rejected" ? "#f8d7da" : "#fff3cd", color: r.status === "Verified" ? C.green : r.status === "Rejected" ? C.red : "#856404" }}>{r.status}</span>
                      </td>
                      <td style={{ padding: "8px 10px" }}>
                        <button onClick={() => alert(`📧 SMS sent to ${r.name}!\nMarksheet ${r.id}: ${r.status}`)} style={{ background: C.navy, color: C.white, border: "none", padding: "4px 10px", borderRadius: 3, fontSize: 11, cursor: "pointer" }}>📧 Notify</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <Btn label="← Back to Dashboard" onClick={() => setPage("dashboard")} color="#888" />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // ── ANALYTICS PAGE ────────────────────────────────────────────────────────
  if (page === "analytics") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title="📊 University Analytics Dashboard — एनालिटिक्स">
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
            {[
              { label: "Total Verified", value: analyticsData.total, icon: "📄", color: C.navy },
              { label: "Genuine", value: analyticsData.verified, icon: "✅", color: C.green },
              { label: "Pending", value: analyticsData.pending, icon: "⏳", color: C.orange },
              { label: "Rejected/Fake", value: analyticsData.rejected, icon: "❌", color: C.red },
            ].map(s => (
              <div key={s.label} style={{ background: s.color, color: C.white, borderRadius: 4, padding: 16, textAlign: "center" }}>
                <div style={{ fontSize: 28 }}>{s.icon}</div>
                <div style={{ fontSize: 28, fontWeight: "bold" }}>{s.value}</div>
                <div style={{ fontSize: 11, marginTop: 4 }}>{s.label}</div>
              </div>
            ))}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
            <Card title="📈 Monthly Verification Trend">
              <div style={{ display: "flex", alignItems: "flex-end", gap: 8, height: 160, padding: "10px 0" }}>
                {analyticsData.monthly.map(m => (
                  <div key={m.month} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <div style={{ fontSize: 11, color: C.navy, fontWeight: "bold", marginBottom: 4 }}>{m.count}</div>
                    <div style={{ width: "100%", background: C.navy, borderRadius: "3px 3px 0 0", height: (m.count / 42) * 120 + "px" }} />
                    <div style={{ fontSize: 11, color: C.gray, marginTop: 4 }}>{m.month}</div>
                  </div>
                ))}
              </div>
            </Card>
            <Card title="🏫 College-wise Report">
              {analyticsData.colleges.map(col => (
                <div key={col.name} style={{ marginBottom: 14 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 4 }}>
                    <span style={{ fontWeight: "bold", color: C.navy }}>{col.name}</span>
                    <span style={{ color: col.fake > 3 ? C.red : C.green, fontWeight: "bold" }}>{col.fake} fake detected</span>
                  </div>
                  <div style={{ background: "#eee", borderRadius: 4, height: 8 }}>
                    <div style={{ width: (col.total / 45) * 100 + "%", height: 8, borderRadius: 4, background: C.navy }} />
                  </div>
                  <div style={{ fontSize: 11, color: C.gray, marginTop: 2 }}>{col.total} total submissions</div>
                </div>
              ))}
            </Card>
          </div>
          <Card title="🔍 AI Accuracy Stats">
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
              {[
                ["95%", "Overall AI Accuracy", C.green],
                ["1.2 min", "Avg Verification Time", C.navy],
                ["16", "Fake Marksheets Caught", C.red],
                ["98", "Auto-Verified (No Officer)", C.green],
                ["28", "Sent for Manual Review", C.orange],
                ["142", "Total This Month", C.navy],
              ].map(([val, label, color]) => (
                <div key={label} style={{ border: "2px solid " + color, borderRadius: 4, padding: 14, textAlign: "center" }}>
                  <div style={{ fontSize: 26, fontWeight: "bold", color }}>{val}</div>
                  <div style={{ fontSize: 11, color: C.gray, marginTop: 4 }}>{label}</div>
                </div>
              ))}
            </div>
          </Card>
          <Btn label="← Back to Home" onClick={() => setPage("home")} color="#888" />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // ── DIGITAL LOCKER PAGE ───────────────────────────────────────────────────
  if (page === "locker") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title="📁 Digital Marksheet Locker — डिजिटल लॉकर">
          <div style={{ background: "linear-gradient(135deg,#4527a0,#311b92)", borderRadius: 4, padding: 16, marginBottom: 20, color: C.white }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 4 }}>Your Personal Document Locker</div>
            <div style={{ fontSize: 12, color: "#d1c4e9" }}>All your verified marksheets stored safely in one place. Share with employers, download anytime, or get QR code for instant verification. Powered by DigiLocker.</div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12, marginBottom: 20 }}>
            {[
              { label: "Documents Stored", value: lockerDocs.length, color: "#4527a0" },
              { label: "All Verified", value: lockerDocs.filter(d => d.status === "Verified").length, color: C.green },
              { label: "Storage Used", value: lockerDocs.length * 1.2 + " MB", color: C.navy },
            ].map(s => (
              <div key={s.label} style={{ background: s.color, color: C.white, borderRadius: 4, padding: 14, textAlign: "center" }}>
                <div style={{ fontSize: 24, fontWeight: "bold" }}>{s.value}</div>
                <div style={{ fontSize: 12, marginTop: 4 }}>{s.label}</div>
              </div>
            ))}
          </div>
          {["FE", "SE", "TE", "BE"].map(year => {
            const docs = lockerDocs.filter(d => d.year === year);
            return (
              <div key={year} style={{ marginBottom: 16 }}>
                <div style={{ fontWeight: "bold", color: C.navy, fontSize: 14, padding: "8px 0", borderBottom: "2px solid " + C.orange, marginBottom: 10 }}>
                  📚 {year} Year Marksheets {docs.length === 0 && <span style={{ fontSize: 12, color: C.gray, fontWeight: "normal" }}>(Not uploaded yet)</span>}
                </div>
                {docs.map(doc => (
                  <div key={doc.id} style={{ border: "1px solid #d1c4e9", borderRadius: 4, padding: 14, marginBottom: 8, background: "#f9f5ff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                      <div style={{ fontWeight: "bold", color: C.navy }}>{doc.branch} — {doc.year} Year</div>
                      <div style={{ fontSize: 12, color: C.gray }}>{doc.college} | {doc.date} | AI Score: {doc.score}%</div>
                      <div style={{ fontSize: 11, color: C.green, fontWeight: "bold", marginTop: 2 }}>✅ {doc.status}</div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                      <button onClick={() => alert("📥 Downloading " + doc.id + ".pdf...")} style={{ background: "#4527a0", color: C.white, border: "none", padding: "6px 12px", borderRadius: 3, fontSize: 12, cursor: "pointer" }}>📥 Download</button>
                      <button onClick={() => { setQrVerifyId(doc.id); setPage("qrVerify"); }} style={{ background: C.green, color: C.white, border: "none", padding: "6px 12px", borderRadius: 3, fontSize: 12, cursor: "pointer" }}>📱 QR Code</button>
                      <button onClick={() => alert("🔗 Share link copied!\nhttps://govdocai.gov.in/verify/" + doc.id)} style={{ background: C.orange, color: C.white, border: "none", padding: "6px 12px", borderRadius: 3, fontSize: 12, cursor: "pointer" }}>🔗 Share</button>
                    </div>
                  </div>
                ))}
                {docs.length === 0 && (
                  <div style={{ border: "2px dashed #d1c4e9", borderRadius: 4, padding: 20, textAlign: "center", color: C.gray, fontSize: 13 }}>
                    <div style={{ fontSize: 28, marginBottom: 6 }}>📄</div>
                    Upload {year} marksheet to store here
                    <div style={{ marginTop: 8 }}>
                      <button onClick={() => setPage("marks")} style={{ background: "#4527a0", color: C.white, border: "none", padding: "6px 16px", borderRadius: 3, fontSize: 12, cursor: "pointer" }}>+ Upload Now</button>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
          <Btn label="+ Upload New Marksheet" onClick={() => setPage("marks")} color="#4527a0" />
          <Btn label="← Back to Dashboard" onClick={() => setPage("dashboard")} color="#888" />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // ── PAPER RE-EVALUATION SUBMISSION PAGE ──────────────────────────────────
  if (page === "reval") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title="📝 Paper Re-Evaluation Request — उत्तर पुस्तिका पुनर्मूल्यांकन">
          <div style={{ background: "linear-gradient(135deg,#c62828,#7f0000)", borderRadius: 4, padding: 16, marginBottom: 20, color: C.white }}>
            <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 4 }}>📋 Request Paper Re-checking</div>
            <div style={{ fontSize: 12, color: "#ffcdd2" }}>
              If you believe your answer paper was checked incorrectly or marks are wrong, submit a re-evaluation request. A senior examiner will re-check your answer sheet within 10 working days.
            </div>
          </div>
          <Alert msg={revalMsg} type={revalMsg.includes("fill") ? "error" : "info"} />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <Input label="Student Full Name *" value={revalForm.studentName} placeholder="As on marksheet" onChange={e => setRevalForm({ ...revalForm, studentName: e.target.value })} />
            <Input label="Roll Number *" value={revalForm.rollNo} placeholder="e.g. 21AI045" onChange={e => setRevalForm({ ...revalForm, rollNo: e.target.value })} />
            <Input label="College Name *" value={revalForm.collegeName} placeholder="e.g. MMIT Lohgaon" onChange={e => setRevalForm({ ...revalForm, collegeName: e.target.value })} />
            <Input label="Subject Name *" value={revalForm.subject} placeholder="e.g. Data Structures" onChange={e => setRevalForm({ ...revalForm, subject: e.target.value })} />
            <Input label="Original Marks Obtained *" value={revalForm.originalMarks} placeholder="Marks as shown on marksheet" onChange={e => setRevalForm({ ...revalForm, originalMarks: e.target.value })} />
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 13, fontWeight: "bold", color: C.navy, marginBottom: 5 }}>Academic Year *</label>
              <select style={{ width: "100%", padding: "10px 12px", border: "1px solid #ccc", borderRadius: 3, fontSize: 14, boxSizing: "border-box" }}
                value={revalForm.year} onChange={e => setRevalForm({ ...revalForm, year: e.target.value })}>
                {["FE", "SE", "TE", "BE"].map(y => <option key={y}>{y}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 13, fontWeight: "bold", color: C.navy, marginBottom: 5 }}>Branch / Department *</label>
              <select style={{ width: "100%", padding: "10px 12px", border: "1px solid #ccc", borderRadius: 3, fontSize: 14, boxSizing: "border-box" }}
                value={revalForm.branch} onChange={e => setRevalForm({ ...revalForm, branch: e.target.value })}>
                {["AI & DS", "CSE", "IT", "Mech", "Civil", "E&TC", "Electrical"].map(b => <option key={b}>{b}</option>)}
              </select>
            </div>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: 13, fontWeight: "bold", color: C.navy, marginBottom: 5 }}>Reason for Re-Evaluation *</label>
            <textarea
              rows={3} placeholder="Describe why you think marks are wrong (e.g. totaling error, answer not read, question skipped)..."
              value={revalForm.reason} onChange={e => setRevalForm({ ...revalForm, reason: e.target.value })}
              style={{ width: "100%", padding: "10px 12px", border: "1px solid #ccc", borderRadius: 3, fontSize: 14, boxSizing: "border-box", resize: "vertical" }}
            />
          </div>
          <div style={{ background: "#fff3cd", padding: 12, borderRadius: 3, fontSize: 12, marginBottom: 16 }}>
            ⚠️ <strong>Note:</strong> Re-evaluation fee of ₹500 per subject is applicable. The decision of the re-evaluation committee will be final. If marks increase, fee is refunded.
          </div>
          <Btn label={revalLoading ? "⏳ Submitting Request..." : "📝 Submit Re-Evaluation Request"} onClick={submitReval} disabled={revalLoading} color="#c62828" />
          <Btn label="📋 My Re-Evaluation History" onClick={() => setPage("revalHistory")} color={C.navy} />
          <Btn label="Back to Dashboard" onClick={() => setPage("dashboard")} color="#888" />
        </Card>
        <Card title="ℹ️ What Happens After You Submit">
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12 }}>
            {[
              { step: "1", icon: "📝", title: "Submit Request", desc: "Fill form & pay ₹500 fee" },
              { step: "2", icon: "📬", title: "Paper Retrieved", desc: "Your answer sheet fetched from records" },
              { step: "3", icon: "👨‍🏫", title: "Senior Examiner Reviews", desc: "Re-checked by different teacher" },
              { step: "4", icon: "📊", title: "Result Updated", desc: "Marks revised if error found" },
            ].map(s => (
              <div key={s.step} style={{ textAlign: "center", padding: 14, border: "1px solid #ffcdd2", borderRadius: 4, background: "#fff8f8" }}>
                <div style={{ width: 28, height: 28, background: "#c62828", color: C.white, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold", fontSize: 13, margin: "0 auto 8px" }}>{s.step}</div>
                <div style={{ fontSize: 24, marginBottom: 6 }}>{s.icon}</div>
                <div style={{ fontWeight: "bold", color: "#c62828", fontSize: 12 }}>{s.title}</div>
                <div style={{ fontSize: 11, color: C.gray, marginTop: 4 }}>{s.desc}</div>
              </div>
            ))}
          </div>
        </Card>
      </div>
      <Footer />
    </div>
  );

  // ── RE-EVALUATION SUBMISSION RESULT PAGE ──────────────────────────────────
  if (page === "revalResult" && revalResult) return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <Card title={"📝 Re-Evaluation Request Submitted — " + revalResult.id}>
          <div style={{ textAlign: "center", padding: "24px 0", borderBottom: "1px solid #eee", marginBottom: 20 }}>
            <div style={{ fontSize: 60, marginBottom: 8 }}>✅</div>
            <div style={{ fontSize: 22, fontWeight: "bold", color: C.green, marginBottom: 4 }}>Request Submitted Successfully!</div>
            <div style={{ fontSize: 14, color: C.gray }}>Your re-evaluation request has been registered.</div>
            <div style={{ marginTop: 12, display: "inline-block", background: "#fff3cd", padding: "6px 16px", borderRadius: 12, fontSize: 13, fontWeight: "bold", color: "#856404" }}>
              ⏳ Under Review
            </div>
          </div>
          <div style={{ background: "#f8f9fa", padding: 16, borderRadius: 3, fontSize: 13, marginBottom: 20 }}>
            <div style={{ fontWeight: "bold", color: C.navy, marginBottom: 12 }}>📋 Request Details</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              {[
                ["Request ID", revalResult.id],
                ["Student Name", revalResult.name],
                ["Roll Number", revalResult.roll],
                ["College", revalResult.college],
                ["Subject", revalResult.subject],
                ["Original Marks", revalResult.originalMarks],
                ["Year / Branch", revalResult.year + " — " + revalResult.branch],
                ["Submitted On", revalResult.submittedOn],
              ].map(([l, v]) => (
                <div key={l} style={{ padding: "6px 0", borderBottom: "1px solid #e0e0e0" }}>
                  <div style={{ fontSize: 11, color: C.gray }}>{l}</div>
                  <div style={{ fontWeight: "bold", color: C.navy }}>{v}</div>
                </div>
              ))}
            </div>
          </div>
          <div style={{ background: "#e8f5e9", padding: 14, borderRadius: 3, marginBottom: 16, fontSize: 13 }}>
            📧 A confirmation SMS & email has been sent. You will be notified within <strong>10 working days</strong> once review is complete.
          </div>
          <div style={{ background: "#fff3cd", padding: 12, borderRadius: 3, marginBottom: 16, fontSize: 12 }}>
            <strong>Your Reason on File:</strong> {revalResult.reason}
          </div>
          <Btn label="📋 View All My Re-Evaluation Requests" onClick={() => setPage("revalHistory")} color={C.navy} />
          <Btn label="📝 Submit Another Request" onClick={() => { setRevalResult(null); setRevalForm({ studentName: "", rollNo: "", collegeName: "", subject: "", year: "SE", branch: "AI & DS", reason: "", originalMarks: "" }); setPage("reval"); }} color="#c62828" />
          <Btn label="Back to Dashboard" onClick={() => setPage("dashboard")} color="#888" />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // ── RE-EVALUATION HISTORY PAGE (Student) ──────────────────────────────────
  if (page === "revalHistory") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
          {[
            { label: "Total Requests", value: revalApps.length, icon: "📝", color: "#c62828" },
            { label: "Marks Revised", value: revalApps.filter(a => a.status === "Marks Revised").length, icon: "✅", color: C.green },
            { label: "Under Review", value: revalApps.filter(a => a.status === "Under Review").length, icon: "⏳", color: C.orange },
            { label: "No Change", value: revalApps.filter(a => a.status === "No Change").length, icon: "➖", color: C.gray },
          ].map(s => (
            <div key={s.label} style={{ background: C.white, borderRadius: 4, padding: 16, boxShadow: "0 1px 4px rgba(0,0,0,0.12)", borderTop: "4px solid " + s.color, textAlign: "center" }}>
              <div style={{ fontSize: 28 }}>{s.icon}</div>
              <div style={{ fontSize: 24, fontWeight: "bold", color: s.color }}>{s.value}</div>
              <div style={{ fontSize: 12, color: C.gray }}>{s.label}</div>
            </div>
          ))}
        </div>
        <Card title="📝 My Re-Evaluation Requests">
          {revalApps.map(app => (
            <div key={app.id} style={{ border: "1px solid #ffcdd2", borderRadius: 4, padding: 16, marginBottom: 16, background: "#fff8f8" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                <div>
                  <span style={{ fontWeight: "bold", color: C.navy, fontSize: 15 }}>{app.subject}</span>
                  <span style={{ marginLeft: 8, fontSize: 12, color: C.gray }}>#{app.id}</span>
                </div>
                <span style={{
                  padding: "4px 14px", borderRadius: 20, fontSize: 12, fontWeight: "bold",
                  background: app.status === "Marks Revised" ? "#d4edda" : app.status === "Under Review" ? "#fff3cd" : "#e0e0e0",
                  color: app.status === "Marks Revised" ? C.green : app.status === "Under Review" ? "#856404" : C.gray
                }}>{app.status}</span>
              </div>
              <div style={{ display: "flex", gap: 20, flexWrap: "wrap", fontSize: 13, marginBottom: 10 }}>
                <span>👤 <strong>{app.name}</strong></span>
                <span>🔢 {app.roll}</span>
                <span>🏫 {app.college}</span>
                <span>📚 {app.year} — {app.branch}</span>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10, background: "#fff", padding: 12, borderRadius: 3, marginBottom: 10, fontSize: 13 }}>
                <div><div style={{ fontSize: 11, color: C.gray }}>Original Marks</div><div style={{ fontWeight: "bold", fontSize: 20, color: C.red }}>{app.originalMarks}</div></div>
                <div style={{ textAlign: "center", color: C.gray, fontSize: 20, paddingTop: 16 }}>→</div>
                <div>
                  <div style={{ fontSize: 11, color: C.gray }}>Revised Marks</div>
                  {app.revisedMarks !== null
                    ? <div style={{ fontWeight: "bold", fontSize: 20, color: app.revisedMarks > app.originalMarks ? C.green : C.gray }}>{app.revisedMarks} {app.revisedMarks > app.originalMarks ? "▲" : "—"}</div>
                    : <div style={{ fontWeight: "bold", fontSize: 14, color: C.orange, paddingTop: 6 }}>Pending</div>
                  }
                </div>
              </div>
              {app.officerNote && (
                <div style={{ background: "#e8f5e9", padding: 10, borderRadius: 3, fontSize: 12, marginBottom: 8 }}>
                  <strong>📋 Officer Note:</strong> {app.officerNote}
                </div>
              )}
              <div style={{ fontSize: 12, color: C.gray }}>
                📅 Submitted: {app.submittedOn}
                {app.reviewedOn && <span style={{ marginLeft: 16 }}>✅ Reviewed: {app.reviewedOn}</span>}
              </div>
            </div>
          ))}
          <Btn label="+ Submit New Re-Evaluation Request" onClick={() => { setRevalForm({ studentName: "", rollNo: "", collegeName: "", subject: "", year: "SE", branch: "AI & DS", reason: "", originalMarks: "" }); setPage("reval"); }} color="#c62828" />
          <Btn label="Back to Dashboard" onClick={() => setPage("dashboard")} color="#888" />
        </Card>
      </div>
      <Footer />
    </div>
  );

  // ── RE-EVALUATION OFFICER REVIEW PAGE ─────────────────────────────────────
  if (page === "revalOfficer") return (
    <div style={{ minHeight: "100vh", background: C.light, fontFamily: "Arial, sans-serif" }}>
      <Header />
      <div style={main}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
          {[
            { label: "Total", value: revalApps.length, icon: "📝", color: "#c62828" },
            { label: "Marks Revised", value: revalApps.filter(a => a.status === "Marks Revised").length, icon: "✅", color: C.green },
            { label: "Pending Review", value: revalApps.filter(a => a.status === "Under Review").length, icon: "⏳", color: C.orange },
            { label: "No Change", value: revalApps.filter(a => a.status === "No Change").length, icon: "➖", color: C.gray },
          ].map(s => (
            <div key={s.label} style={{ background: C.white, borderRadius: 4, padding: 16, boxShadow: "0 1px 4px rgba(0,0,0,0.12)", borderTop: "4px solid " + s.color }}>
              <div style={{ fontSize: 28 }}>{s.icon}</div>
              <div style={{ fontSize: 24, fontWeight: "bold", color: s.color }}>{s.value}</div>
              <div style={{ fontSize: 12, color: C.gray }}>{s.label}</div>
            </div>
          ))}
        </div>
        <Card title="👨‍🏫 Officer — Paper Re-Evaluation Review Panel">
          {revalApps.map(app => (
            <div key={app.id} style={{ border: "2px solid " + (app.status === "Under Review" ? C.orange : "#e0e0e0"), borderRadius: 4, padding: 16, marginBottom: 20, background: app.status === "Under Review" ? "#fffdf0" : "#fafafa" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <div>
                  <span style={{ fontWeight: "bold", color: C.navy, fontSize: 16 }}>{app.name}</span>
                  <span style={{ marginLeft: 8, fontSize: 12, color: C.gray }}>#{app.id}</span>
                  {app.status === "Under Review" && <span style={{ marginLeft: 8, background: C.orange, color: C.white, padding: "2px 8px", borderRadius: 10, fontSize: 11, fontWeight: "bold" }}>ACTION REQUIRED</span>}
                </div>
                <span style={{
                  padding: "4px 14px", borderRadius: 20, fontSize: 12, fontWeight: "bold",
                  background: app.status === "Marks Revised" ? "#d4edda" : app.status === "Under Review" ? "#fff3cd" : "#e0e0e0",
                  color: app.status === "Marks Revised" ? C.green : app.status === "Under Review" ? "#856404" : C.gray
                }}>{app.status}</span>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 10, background: "#f5f5f5", padding: 12, borderRadius: 3, marginBottom: 12, fontSize: 13 }}>
                {[["Subject", app.subject], ["Roll No", app.roll], ["College", app.college], ["Year / Branch", app.year + " — " + app.branch], ["Original Marks", app.originalMarks], ["Submitted On", app.submittedOn]].map(([l, v]) => (
                  <div key={l}><span style={{ color: C.gray }}>{l}: </span><strong style={{ color: C.navy }}>{v}</strong></div>
                ))}
              </div>
              <div style={{ background: "#fff3cd", padding: 10, borderRadius: 3, marginBottom: 12, fontSize: 13 }}>
                <strong>📋 Student's Reason:</strong> {app.reason}
              </div>
              {app.status === "Under Review" && (
                <div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
                    <div>
                      <label style={{ display: "block", fontSize: 13, fontWeight: "bold", color: C.navy, marginBottom: 5 }}>Revised Marks (after re-check)</label>
                      <input
                        type="number" placeholder="Enter revised marks"
                        value={revalRevisedMarks[app.id] || ""}
                        onChange={e => setRevalRevisedMarks({ ...revalRevisedMarks, [app.id]: e.target.value })}
                        style={{ width: "100%", padding: "10px 12px", border: "2px solid #c62828", borderRadius: 3, fontSize: 14, boxSizing: "border-box" }}
                      />
                    </div>
                    <div>
                      <label style={{ display: "block", fontSize: 13, fontWeight: "bold", color: C.navy, marginBottom: 5 }}>Officer Note / Remarks</label>
                      <input
                        placeholder="Explain findings..."
                        value={revalOfficerComment[app.id] || ""}
                        onChange={e => setRevalOfficerComment({ ...revalOfficerComment, [app.id]: e.target.value })}
                        style={{ width: "100%", padding: "10px 12px", border: "1px solid #ccc", borderRadius: 3, fontSize: 14, boxSizing: "border-box" }}
                      />
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <button style={{ background: C.green, color: C.white, border: "none", padding: "10px 18px", borderRadius: 3, cursor: "pointer", fontSize: 13, fontWeight: "bold" }}
                      onClick={() => {
                        const revised = parseInt(revalRevisedMarks[app.id]);
                        const note = revalOfficerComment[app.id] || "Marks revised after re-checking.";
                        if (!revised) { alert("Please enter revised marks first!"); return; }
                        updateRevalApp(app.id, "Marks Revised", revised, note);
                        alert(`✅ Marks Revised for ${app.name}!\nOriginal: ${app.originalMarks} → Revised: ${revised}\nStudent will be notified.`);
                      }}>✅ Mark as Revised</button>
                    <button style={{ background: C.gray, color: C.white, border: "none", padding: "10px 18px", borderRadius: 3, cursor: "pointer", fontSize: 13, fontWeight: "bold" }}
                      onClick={() => {
                        const note = revalOfficerComment[app.id] || "Re-checked. No error found. Marks remain unchanged.";
                        updateRevalApp(app.id, "No Change", app.originalMarks, note);
                        alert(`➖ No Change for ${app.name}.\nOriginal marks of ${app.originalMarks} are correct.\nStudent will be notified.`);
                      }}>➖ No Change Required</button>
                    <button style={{ background: C.navy, color: C.white, border: "none", padding: "10px 18px", borderRadius: 3, cursor: "pointer", fontSize: 13, fontWeight: "bold" }}
                      onClick={() => alert(`📧 Reminder sent to senior examiner for ${app.id}`)}>📧 Escalate to Senior</button>
                  </div>
                </div>
              )}
              {app.status !== "Under Review" && app.officerNote && (
                <div style={{ background: "#e8f5e9", padding: 10, borderRadius: 3, fontSize: 13 }}>
                  <strong>📋 Decision Note:</strong> {app.officerNote}
                  {app.revisedMarks !== null && <div style={{ marginTop: 6 }}>Revised Marks: <strong style={{ color: app.revisedMarks > app.originalMarks ? C.green : C.gray, fontSize: 15 }}>{app.revisedMarks}</strong></div>}
                  {app.reviewedOn && <div style={{ marginTop: 4, fontSize: 11, color: C.gray }}>Reviewed on: {app.reviewedOn}</div>}
                </div>
              )}
            </div>
          ))}
          <Btn label="← Back to Officer Dashboard" onClick={() => setPage("officer")} color="#888" />
        </Card>
      </div>
      <Footer />
    </div>
  );

  return null;
}
